import * as React from "react";
import { Container, Modal, InputGroup, Form, FormControl, Dropdown, Button, ButtonGroup, OverlayTrigger, Tooltip, Spinner } from "react-bootstrap";
import BootstrapTable from 'react-bootstrap-table-next';
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import { accountService } from "../../Common/Services/account";
import { DateObject, Calendar } from "react-multi-date-picker";
import OutsideClickHandler from "react-outside-click-handler";
import { DateRange } from 'react-date-range';
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import { Typeahead, Menu, MenuItem } from "react-bootstrap-typeahead";
import paginationFactory, { PaginationProvider, PaginationListStandalone, SizePerPageDropdownStandalone } from 'react-bootstrap-table2-paginator';
import "./search.scss";
import { FiChevronDown } from "react-icons/fi";
import { Utils } from "../../Common/Utilis";
import { TransactionSlideout } from "../Register/TransactionSlideout";
import { InvoiceEntrySlideout } from "../Register/InvoiceEntrySlideout";
import { TransferSlideout } from "../Register/TransferSlideout";
import { TransactionSlideout as JournalSlideOut } from '../Accounting/JournalEntry/transactionSlideout';
import { CreditCardSlideout } from '../Register/CreditCardSlideout';
import { Register as registersevice } from "../../Common/Services/Register";
import { CSVLink } from "react-csv";
import { resolve, reject } from "q";
import { ToastContainer, toast } from "react-toastify";
import { LaborPerformance as laborPerformance } from "../../Common/Services/LaborPerfomance";
import { SingleSearchDropdownList } from "../../Common/Components/SingleSearchDropdownList";
import { MultiSelectCoaWithSearch } from "../../Common/Components/MultiSelectCoaWithSearch";
import { DailyActivitySlideOut } from "../Register/DailyActivitySlideOut";
import moment from "moment";
import {
  RoleSubPermissionSetting,
  IPageSubPermissionRole,
} from "../../Common/Services/RoleSubPermissionSetting";
import { confirmAlert } from "react-confirm-alert";
let exportDataSet: any = [];
export class Search extends React.Component<any, any> {
  columns = [{
    dataField: 'lettercode',
    text: 'EHID',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.lettercode}</EllipsisWithTooltip>
      )
    }

  }, {
    dataField: 'date',
    text: 'Date',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.date}</EllipsisWithTooltip>
      )
    }

  }, {
    dataField: 'period',
    text: 'Act. Per',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.period}</EllipsisWithTooltip>
      )
    }

  }, {
    dataField: 'duedate',
    text: 'Due Date',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.duedate}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'vendor',
    text: 'Vendor',
    headerClasses: 'width-150',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.vendor}</EllipsisWithTooltip>
      )
    }
  },
  {
    dataField: 'subvendor',
    text: 'Subvendor',
    headerClasses: 'width-150',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.subvendor}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'invoiceNo',
    text: 'Inv. No.',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.invoiceNo}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'billdate',
    text: 'Inv. Date',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.billdate}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'coa',
    text: 'COA',
    headerClasses: 'width-150',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.coa + " - " + row.coaName}</EllipsisWithTooltip>
      )
    }

  }, {
    dataField: 'ckno',
    text: 'Check No.',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.ckno}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'payment',
    text: 'Payment',
    headerClasses: 'width-100 align-right',
    classes: 'align-right',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{this.state.tableActiveTab === "regular" ? row.transamount : row.payment}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'deposit',
    text: 'Deposit',
    headerClasses: 'width-100 align-right',
    classes: 'align-right',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{this.state.tableActiveTab === "regular" ? row.depositTotal : row.deposit}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'transtotal',
    text: 'Total',
    headerClasses: 'width-100 align-right',
    classes: 'align-right',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.transtotal}</EllipsisWithTooltip>
      )
    }
  }, {
    dataField: 'acctName',
    text: 'Ledger',
    headerClasses: 'width-150',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.acctName}</EllipsisWithTooltip>
      )
    }

  }, {
    dataField: 'cl',
    text: 'CL',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.cl}</EllipsisWithTooltip>
      )
    }
  },

  {
    dataField: 'description',
    text: 'Description',
    headerClasses: 'width-100 align-center',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <>
          {row.description.toString().trim().length >0 ? (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id={"description-list"}>
                  {row.description}
                </Tooltip>
              }
            >
              <div className="notes d-flex align-items-center">
                <div className="icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5556 2.4H11.3889V1H9.94444V2.4H7.05556V1H5.61111V2.4H3.44444C2.64783 2.4 2 3.0279 2 3.8V13.6C2 14.3721 2.64783 15 3.44444 15H13.5556C14.3522 15 15 14.3721 15 13.6V3.8C15 3.0279 14.3522 2.4 13.5556 2.4ZM3.44444 13.6V4.5H5.61111H7.05556H9.94444H11.3889H13.5556V3.8L13.557 13.6H3.44444Z" fill="#6A6E73" />
                    <path d="M4.66675 6H11.3334V7.33333H4.66675V6ZM4.66675 8.66667H8.00008V10H4.66675V8.66667Z" fill="#6A6E73" />
                  </svg>
                </div>
                <div className="count">1</div>
              </div>
            </OverlayTrigger>
          ) : ""}
        </>

      );
    },
  },

  {
    dataField: 'internalnotes',
    text: 'Notes',
    headerClasses: 'width-100 align-center',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <>
          {row.internalnotes.toString() !== "" ? (
            <OverlayTrigger
              placement="bottom"
              delay={{ show: 250, hide: 400 }}
              overlay={
                <Tooltip id={"Notes-list"}>
                  {row.internalnotes}
                </Tooltip>
              }
            >
              <div className="notes d-flex align-items-center">
                <div className="icon">
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M13.5556 2.4H11.3889V1H9.94444V2.4H7.05556V1H5.61111V2.4H3.44444C2.64783 2.4 2 3.0279 2 3.8V13.6C2 14.3721 2.64783 15 3.44444 15H13.5556C14.3522 15 15 14.3721 15 13.6V3.8C15 3.0279 14.3522 2.4 13.5556 2.4ZM3.44444 13.6V4.5H5.61111H7.05556H9.94444H11.3889H13.5556V3.8L13.557 13.6H3.44444Z" fill="#6A6E73" />
                    <path d="M4.66675 6H11.3334V7.33333H4.66675V6ZM4.66675 8.66667H8.00008V10H4.66675V8.66667Z" fill="#6A6E73" />
                  </svg>
                </div>
                <div className="count">1</div>
              </div>
            </OverlayTrigger>
          ) : ""}
        </>

      );
    },
  },

  {
    dataField: 'project',
    text: 'Project',
    headerClasses: 'width-100',
    formatter: (cell: any, row: any, rowIndex: any) => {
      return (
        <EllipsisWithTooltip placement="bottom">{row.project}</EllipsisWithTooltip>
      )
    }
  },

  {
    dataField: '',
    text: '',
    headerClasses: 'sticky-last-column width-50',
    classes: 'sticky-last-column width-50',
  }];

  private datePickerRef: any;
  private searchBtnRef: any;
  constructor(props: any) {
    super(props);
    this.datePickerRef = React.createRef();
    this.searchBtnRef = React.createRef();
    this.state = {
      monthRange: [
        new DateObject(),
        new DateObject()
      ],
      toggleMatchActiveTab: 'contains',
      isExactMatchChecked: false,
      startMonthRange: '',
      endMonthRange: '',
      excelfileName: '',
      searchStart: false,
      exportData: [],
      isColumnChange: true,
      columns: this.columns,
      loader: false,
      searcResult: [],
      dateRange: [{ startDate: new Date(), endDate: new Date(), key: 'selection', color: "#E5F5FF" }],
      displayDate: "Date",
      tableActiveTab: "regular",
      calendarActiveTab: "transaction",
      selectedTransationType: "Select",
      isCalendarOpen: false,
      isCustomModalOpen: false,
      isCustomModalType: '',
      selectedYesNo: "Yes",
      txtMoreSearch: "",
      tableColumnList: [
        { id: "lettercode", name: "EHID", isChecked: true, disabled: true },
        { id: "date", name: "Date", isChecked: true, disabled: true },
        { id: "accountPeriod", name: "Act. Per", isChecked: true, disabled: false },
        { id: "duedate", name: "Due", isChecked: true, disabled: false },
        { id: "vendor", name: "Vendor", isChecked: true, disabled: false },
        { id: "subvendor", name: "Subvendor", isChecked: true, disabled: false },
        { id: "invoiceNo", name: "Inv. No.", isChecked: true, disabled: false },
        { id: "invdate", name: "Inv. Date", isChecked: true, disabled: false },
        { id: "coaName", name: "COA", isChecked: true, disabled: false },
        { id: "ckno", name: "Check No.", isChecked: true, disabled: false },
        { id: "payment", name: "Payment", isChecked: true, disabled: false },
        { id: "deposit", name: "Deposit", isChecked: true, disabled: false },
        { id: "transtotal", name: "Total", isChecked: true, disabled: false },
        { id: "transamount", name: "Ledger", isChecked: true, disabled: false },
        { id: "cl", name: "CL", isChecked: true, disabled: false },
        { id: "description", name: "Description", isChecked: true, disabled: false },
        { id: "internalnotes", name: "Notes", isChecked: true, disabled: false },
        { id: "project", name: "Project", isChecked: false, disabled: false },
      ],
      densityName: "compact",
      allDensity: [
        { densityName: "WIDE", eventName: "wide" },
        { densityName: "NARROW", eventName: "narrow" },
        { densityName: "COMPACT", eventName: "compact" },
      ],

      selectCategories: { categoriesName: "Vendor", eventName: "vendor", dbName: "vid" },
      allcategories: [
        { categoriesName: "Vendor", eventName: "vendor", dbName: "vid" },
        { categoriesName: "Check No.", eventName: "check-no", dbName: "ckno" },
        { categoriesName: "COA", eventName: "coa", dbName: "coa" },
        { categoriesName: "Amount", eventName: "amount", dbName: "amount" },
        { categoriesName: "Notes & Descriptions", eventName: "notes-description", dbName: "internalnotes" },
        { categoriesName: "Invoice No.", eventName: "invoice-no", dbName: "invoiceNo" },
      ],
      moreFilters: [
        { filterName: "Amount", eventName: "amount" },
        { filterName: "Check No.", eventName: "check-no" },
        { filterName: "Cleared Acct. Per.", eventName: "cleared-acct-per" },
        { filterName: "COA", eventName: "coa" },
        { filterName: "Customer No.", eventName: "Customer No." },
        { filterName: "Exclude Unpaid Invoices & Unapproved Transactions", eventName: "Exclude Unpaid Invoices & Unapproved Transactions" },
        { filterName: "Include Daily Activity Entries", eventName: "Include Daily Activity Entries" },
        { filterName: "Invoice No.", eventName: "invoice-no" },
        { filterName: "Ledger Type", eventName: "ledger-type" },
        { filterName: "Notes & Descriptions", eventName: "notes-description" },
        { filterName: "Transaction Type", eventName: "Transaction Type" },
        { filterName: "Vendor", eventName: "vendor" },
      ],

      ledgerTypeList: [
        { ledgerType: "Credit Card", eventName: "cc" },
        { ledgerType: "Miscellaneous", eventName: "mis" },
        { ledgerType: "Operating", eventName: "opr" },
        { ledgerType: "Payroll", eventName: "pay" },
      ],

      transactionList: [
        { transationName: "Check/ACH", eventName: "Check/ACH" },
        { transationName: "Deposit", eventName: "Deposit" },
        { transationName: "Journal Entry", eventName: "Journal Entry" },
        { transationName: "Transfer", eventName: "Transfer" },
        { transationName: "Withdrawal", eventName: "Withdrawal" },
        { transationName: "Adjustments", eventName: "Adjustments" },
        { transationName: "Payroll", eventName: "Payroll" },
        { transationName: "Credit card", eventName: "Credit card" },
        { transationName: "ePay", eventName: "ePay" },
      ],
      selectedMoreSearch: [],
      selectedSearch: [],
      searchList: [],
      searchData: [],
      chipList: [],
      VendorList: [],
      coaList: [],
      customerNoList: [],
      allehid: [],
      allehidData: [],
      isSelect: true,

      //row click variables
      isSlideOut: false,
      isTransferSlideOut: false,
      isTRSideOut: false,
      isCCSlideout: false,

      pageType: "",
      sildeoutHid: "",
      trUniqueNo: 0,
      oprId: -1,
      vid: 0,
      registerRequest: { hotelID: -1, lettercode: '', oprID: -1, acctType: "" },
      chipClick: "",
      index: null,
      startDate: this.dateFormat(new Date()),
      endDate: this.dateFormat(new Date()),
      isSearched: false,
      selectedLedgerType: "Select",
      isConfirmationModal: false,
      isRegularOrSplitClicked: false,
      isSubVendorBanner: false,
      isTransactionpopupshow: false,
      exportCalendarActiveTab: "",
      ehidPlaceholder: "Select EHID",
      exportEhidList: [],
      selectedExportEhid: -1,
      exportMonthRange: [
        new DateObject(),
        new DateObject()
      ],
      exportStartMonthRange: '',
      exportEndMonthRange: '',
      exportDateRange: [{ startDate: new Date(), endDate: new Date(), key: 'selection', color: "#E5F5FF" }],
	    exportStartDate: this.dateFormat(new Date()),
      exportEndDate: this.dateFormat(new Date()),
      isSearchEHIDFlagBanner: false,
      selectedMultiCOAs: [],
      updatedMultiCOAs: [],
      isDailyActivityOpen: false,
      dailyActivityRequest: {},
      depReqDetails: "",
      isDailyActivityClickable: true,
    };
    this.handleTypeAheadBlur = this.handleTypeAheadBlur.bind(this);
  }

  componentDidMount() {
    // this.featureFlagForTenant();      //Added to check if Daily Activity Slideout should open or not.
    this.bindEHID();
    this.AccountSearchFilterALLType();
    this.getDefaultColumn();
    this.getWebTimeClockManagerPermission();
  }

  featureFlagForTenant = () => {
    let isDailyActivityClickable = false;
    accountService.GetFeatureFlagForTenant()
      .then(async (result: any | null) => {
        if (result !== null) {
          isDailyActivityClickable = result.some((o: any) => o?.featureValue?.toString().toLowerCase() === "dailyactivitydeposit" && o?.featureStatus?.toString().toLowerCase() === "yes");
        }
        this.setState({ isDailyActivityClickable });
      });
  }

  handleModalClose = () => {
    this.setState({ 
      isTransactionpopupshow: false,
      exportCalendarActiveTab: "",
      selectedExportEhid: -1,
        exportMonthRange: [
          new DateObject(),
          new DateObject()
        ],
      exportStartMonthRange: '',
      exportEndMonthRange: '',
      exportDateRange: [{ startDate: new Date(), endDate: new Date(), key: 'selection', color: "#E5F5FF" }],
      exportStartDate: this.dateFormat(new Date()),
      exportEndDate: this.dateFormat(new Date()),
    });
  };
  handleTripleDotsMenu = (eventKey: any) => {
    if(eventKey === "transactionExportByEhid"){
      this.setState({ isTransactionpopupshow: true, exportCalendarActiveTab: "exportTransaction", });
    }
  }
  handleEhidSelectedItem = (controlID: any, ehid: any) => {
    this.setState({selectedExportEhid: ehid});
  }

  handleTransactionExportByEhidData = () => {
  let request: any = {};
	request.EHID = this.state.selectedExportEhid;
	request.DateType = this.state.exportCalendarActiveTab === "exportAccounting" ? "period" : "date";
  if (this.state.exportCalendarActiveTab === "exportAccounting") {
    request.StartDate = this.dateFormat(this.state.exportMonthRange[0]);
	  request.EndDate = this.dateFormat(this.state.exportMonthRange[1]);
  }
  else {
    request.StartDate = this.dateFormat(this.state.exportDateRange[0].startDate);
	  request.EndDate = this.dateFormat(this.state.exportDateRange[0].endDate);
  }
	
	accountService.SaveSearchExportByEHID(request)
    .then(async (result: any | null) => {
      if (result != null) {
        if (result?.status.toLowerCase() === "success") {
          let msg = "This search will take time to run.  We will send an email to " + result?.email + " with the report once it is ready.";
          toast.success( msg, 
            { 
              position: toast.POSITION.BOTTOM_RIGHT, 
              containerId: "SearchExportByEHID123" 
            });
        this.handleModalClose();
        }
        else {
          // Do this
        }
      }
    })
    .catch((err: any) => {
      this.setState({ loader: false });
      Utils.toastError(err.message, {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      reject();
    });
  }

  getWebTimeClockManagerPermission = () => {
    let localStorageUser = JSON.parse(localStorage.getItem("storage")!);
    let requestObject = {} as IPageSubPermissionRole;
    requestObject.permissionID = 148;
    requestObject.Module = "Accounting";
    requestObject.Type = "page";
    requestObject.RoleID = localStorageUser.rolId;
    requestObject.TenantID = localStorageUser.tenantID;
    RoleSubPermissionSetting.GetPageSubPermissionWebClockDetails(requestObject)
      .then(async (result: any | null) => {
        let { hasAddPermission } = this.state;
        if (result != null && result.length > 0) {
          for (let index = 0; index < result.length; index++) {
            if (result[index].displayName.toString().toLowerCase() === "Add".toLocaleLowerCase() && result[index].moduleName === "Accounting") {
              hasAddPermission = true;
            }
          }
          this.setState({ hasAddPermission });
        }
        resolve();
      })
      .catch((err: any) => {
        Utils.toastError(`Server Error, ${err}`, {
          position: toast.POSITION.BOTTOM_RIGHT
        });
        reject();
      });
  };

  bindEHID() {
    accountService.AccountSearchHotels()
      .then(async (result: any | null) => {
        if (result !== null) {
          let allehid: any = [];
          result.forEach((element, inx) => {
            let ehidobj: any = {};
            ehidobj.ehidVal = element.id;
            ehidobj.ehidName = element.label;
            ehidobj.hid = element.description;
            ehidobj.isChecked = false;
            allehid.push(ehidobj);
           
          });
          let exportEhidList: any = [];
          result.forEach((element, inx) => {
            let ehidobj1: any = {};
            ehidobj1.id = element.id;
            ehidobj1.name = element.label;
            ehidobj1.hid = element.description;
            exportEhidList.push(ehidobj1);
           
          })
          this.setState({ allehid: allehid, allehidData: allehid, exportEhidList, }, () => {
            if (allehid.length === 1)
              this.defaultHIDSelection(allehid[0]);
          });
        }
      });
  }

  defaultHIDSelection = (items) => {
    let checked = true;
    this.setState({ isFilter: false });
    const allehid = [...this.state.allehid];
    const index = allehid.findIndex((x) => x.ehidVal === items.ehidVal);
    allehid[index].isChecked = checked;
    let searchData = [...this.state.searchData];
    if (checked) {
      searchData.push({ name: "hid", value: items.ehidVal, value2: "" });
    } else {
      if (searchData.filter((x) => x.name === "hid" && x.value === items.ehidVal).length > 0) {
        const index = searchData.findIndex((x) => x.name === "hid" && x.value === items.ehidVal);
        searchData.splice(index, 1);
      }
    }
    this.setState({ allehid, searchData });
    let CheckedHID: any = [];
    CheckedHID = allehid.filter(x => x.isChecked === true);
    if (CheckedHID.length === allehid.length) {
      this.setState({ isSelect: false });
    } else {
      this.setState({ isSelect: true });
    }
    if (CheckedHID.length > 0) {
      this.setState({ isFilter: true });
    }
  }

  AccountSearchFilterALLType() {
    accountService.AccountSearchFilterALLType()
      .then(async (result: any | null) => {
        if (result !== null) {
          this.setState({
            searchMoreList: result.vendorSearchList,
            searchList: result.vendorSearchList,
            VendorList: result.vendorSearchList,
            coaList: result.coaSearchList,
            customerNoList: result.contractSearchList,
          });
        }
      });
  }

  categoriesSelect = (item: any) => {

    let searchData = Object.assign([], JSON.parse(JSON.stringify(this.state.searchData)));

    let filteredData = searchData.filter((x) => x.name === "hid" || x.name === "date" || x.name === "accperiod" );

    this.setState({
      searchList: [], selectedSearch: [], searchData: filteredData,
      chipList: [], isSearched: false, selectedMultiCOAs: [], updatedMultiCOAs: [],
    }, () => {

      if (item.categoriesName === "Vendor") {
        this.setState({ searchList: this.state.VendorList });
      }
      if (item.categoriesName === "COA") {
        this.setState({ searchList: this.state.coaList });
      }
    });
    this.setState({ selectCategories: item, isExactMatchChecked: false });
  }

  onTypeAheadInputChange(val) {
    if (val.trim().length > 0) {
      let searchList = this.state.searchList.filter(e => (e.label.toLowerCase() === val.toLowerCase()))
      if (searchList.length > 0) {
        this.setState({ selectedSearch: [] }, () => {
          this.setState({ selectedSearch: searchList });
        });
        this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: searchList[0].id, value2: searchList[0].label });
      } else {
        this.setState({ selectedSearch: [], isSearched: false }, () => {
          this.setState({ selectedSearch: [{ id: -1, label: val }] })
        });
        if (this.state.selectCategories.dbName === "vid") {
          this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: -1, value2: val });
        } else {
          this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: val, value2: val });
        }

      }
    } else {
      let searchData = [...this.state.searchData];
      if (searchData.filter((x) => x.name === this.state.selectCategories.dbName).length > 0) {
        const index = searchData.findIndex((x) => x.name === this.state.selectCategories.dbName);
        searchData.splice(index, 1);
      }
      this.setState({ searchData });
    }
  }

  typeheadChange(e: any) {
    this.setState({ selectedSearch: e });
    if (e.length > 0) {
      this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: e[0].id, value2: e[0].label });
    } else {
      let searchData = [...this.state.searchData];
      if (searchData.filter((x) => x.name === this.state.selectCategories.dbName).length > 0) {
        const index = searchData.findIndex((x) => x.name === this.state.selectCategories.dbName);
        searchData.splice(index, 1);
      }
      this.setState({ searchData });
    }
  }

  txtSearch(e: any) {
    this.setState({ selectedSearch: e.target.value });
    this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: e.target.value, value2: "" });
    if (e.target.value.length === 0) {
      this.setState({ isSearched: false });
    }
  }

  onChangeHIDFilter = (event, items) => {
    this.setState({ isFilter: false });
    let allehid = Object.assign([], JSON.parse(JSON.stringify(this.state.allehid)));
    let allehidData = Object.assign([], JSON.parse(JSON.stringify(this.state.allehidData)));
    const index = allehid.findIndex((x) => x.ehidVal === items.ehidVal);
    allehid[index].isChecked = event.target.checked;
    const index1 = allehidData.findIndex((x) => x.ehidVal === items.ehidVal);
    allehidData[index1].isChecked = event.target.checked;
    let searchData = [...this.state.searchData];
    if (event.target.checked) {
      searchData.push({ name: "hid", value: items.ehidVal, value2: "" });
    } else {
      if (searchData.filter((x) => x.name === "hid" && x.value === items.ehidVal).length > 0) {
        const index = searchData.findIndex((x) => x.name === "hid" && x.value === items.ehidVal);
        searchData.splice(index, 1);
      }
    }


    let CheckedHID: any = [];
    CheckedHID = allehidData.filter(x => x.isChecked === true);
    if (CheckedHID.length > 0) {
      this.setState({ isFilter: true });
    }

    this.setState({ allehid, allehidData, searchData },()=>{

      if (this.state.isSearched) {
        this.handleSearch("other");
      }
    });
    
  }

  handleSelectAll = (e: any) => {
    let allehid = Object.assign([], JSON.parse(JSON.stringify(this.state.allehid)));
    let allehidData = Object.assign([], JSON.parse(JSON.stringify(this.state.allehidData)));
    let searchData = [...this.state.searchData];
    allehidData.forEach((element) => {
      element.isChecked = true;
      if (searchData.filter(e => e.name === "hid" && e.value === element.ehidVal).length > 0) {
        // Do this
      } else {
        searchData.push({ name: "hid", value: element.ehidVal, value2: "" });
      }

    });
    allehid.forEach((element) => {
      element.isChecked = true;
    });

    this.setState({ isFilter: true, allehid, allehidData, isSelect: false, searchData },()=>{
      if (this.state.isSearched) {
        this.handleSearch("other");
      }
    });
  };

  handleClearAll = (e: any) => {
    let allehid = Object.assign([], JSON.parse(JSON.stringify(this.state.allehid)));
    let allehidData = Object.assign([], JSON.parse(JSON.stringify(this.state.allehidData)));
    let searchData = [...this.state.searchData];
    allehidData.forEach((element) => {
      element.isChecked = false;
      if (searchData.filter((x) => x.name === "hid" && x.value === element.ehidVal).length > 0) {
        const index = searchData.findIndex((x) => x.name === "hid" && x.value === element.ehidVal);
        searchData.splice(index, 1);
      }
    });
    allehid.forEach((element) => {
      element.isChecked = false;
    });
    this.setState({ allehid, allehidData, isSelect: true, isFilter: false, searchData },()=>{
      if (this.state.isSearched) {
        this.handleSearch("other");
      }
    })
  };

  addCategoryRequest(obj) {
    let obj1 = obj
    let Listdata = [...this.state.searchData];
    if (Listdata.filter(e => e.name === obj.name).length > 0) {
      const index = Listdata.findIndex((x) => x.name === obj.name);
      Listdata[index].value = obj.value;
      Listdata[index].value2 = obj.value2;
      Listdata[index].type = this.state.selectCategories.categoriesName === "Vendor" || this.state.selectCategories.categoriesName === "COA" ? "" : 
        this.state.isExactMatchChecked ? "exact" : "contains" ;
    } else {
      obj1.type = this.state.selectCategories.categoriesName === "Vendor" || this.state.selectCategories.categoriesName === "COA" ? "" : 
        this.state.isExactMatchChecked ? "exact" : "contains" ;
      Listdata.push(obj1);
    }
    this.setState({ searchData: [] }, () => {
      this.setState({ searchData: Listdata })
    });

  }
  toggleSelectTransaction = (eventKey: any) => {
    this.setState({ exportCalendarActiveTab: eventKey });
    if(eventKey === "exportAccounting"){
      let exportStartMonthRange = (this.state.exportMonthRange[0].month.number.toString().length > 1 ? this.state.exportMonthRange[0].month.number : "0" + this.state.exportMonthRange[0].month.number)  + "/" + this.state.exportMonthRange[0].year.toString().substring(2, 4);
      let exportEndMonthRange = this.state.exportMonthRange.length > 1 ? (this.state.exportMonthRange[1].month.number.toString().length > 1 ? this.state.exportMonthRange[1].month.number : "0" + this.state.exportMonthRange[1].month.number) + "/" + this.state.exportMonthRange[1].year.toString().substring(2, 4) : "";
      this.setState({ exportStartMonthRange, exportEndMonthRange,});
    }
  }

  toggleSelect = (eventKey: any) => {
    if (eventKey !== this.state.calendarActiveTab) {
      this.setState({ calendarActiveTab: eventKey });
    }
    if(eventKey === "accounting"){

      let startMonthRange = (this.state.monthRange[0].month.number.toString().length > 1 ? this.state.monthRange[0].month.number : "0" + this.state.monthRange[0].month.number)  + "/" + this.state.monthRange[0].year.toString().substring(2, 4);
      let endMonthRange = this.state.monthRange.length > 1 ? (this.state.monthRange[1].month.number.toString().length > 1 ? this.state.monthRange[1].month.number : "0" + this.state.monthRange[1].month.number) + "/" + this.state.monthRange[1].year.toString().substring(2, 4) : "";
      this.setState({ startMonthRange, endMonthRange,});
    }
    
  }

  toggleMatchSelector = (eventKey: any) => {
    this.setState({toggleMatchActiveTab : eventKey}, () => {
    });
  }

  exactMatchCheckToggle = (eventKey: any) => {
    this.setState({isExactMatchChecked : eventKey.target.checked}, () => {
      let searchData = Object.assign([], JSON.parse(JSON.stringify(this.state.searchData)));
      if (searchData.filter(e => e.name === this.state.selectCategories.dbName).length > 0) {
        const index = searchData.findIndex((x) => x.name === this.state.selectCategories.dbName);
        searchData[index].type = this.state.isExactMatchChecked ? "exact" : "contains";
      }
      this.setState({searchData});
    });
  }

  toggleTableSelect = (eventKey: any) => {
    let data = Object.assign([], JSON.parse(JSON.stringify(this.state.tableColumnList)));
    let { columns } = this.state;

    if (eventKey === "regular") {
      data.map((item, inx) => {
        if (item.id === "coaName" || item.id === "description" || item.id === "subvendor" || item.id === "project") {
          data[inx].disabled = true;
          columns[inx].hidden = true;
        }
        else if (item.id === "payment") {
          columns[inx].dataField = 'transamount';
        }
        else if (item.id === "deposit") {
          columns[inx].dataField = 'depositTotal';
        }
      })
    }
    else {
      data.map((item, inx) => {
        if (item.id === "coaName" || item.id === "description" || item.id === "subvendor" || item.id === "project") {
          data[inx].disabled = false;
          columns[inx].hidden = data[inx].isChecked ? false : true;
        }
        else if (item.id === "payment" || item.id === "deposit") {
          columns[inx].dataField = item.id;
        }
      })
    }

    this.setState({ tableColumnList: data, columns, isColumnChange: false }, () => {
      this.setState({ isColumnChange: true })
    })
  }

  regularOrSplitClick = (eventKey: any) => {
    this.setState({ tableActiveTab: eventKey, isRegularOrSplitClicked: true }, () => {
      if (this.state.isSearched) {
        this.handleSearch("other");
      }
    });
  }

  handleCalendarOpen = () => {
    if (this.state.displayDate === "Date") {
      let startDate = this.dateFormat(new Date());
      let endDate = this.dateFormat(new Date());
      let monthRange = [
        new DateObject(),
        new DateObject()
      ];
      let $date = new Date(monthRange[0].month.number +"/01/"+ monthRange[0].year.toString().substring(2, 4));
      monthRange[0] = new DateObject($date);
      let startMonthRange = '';
      let endMonthRange = '';
      this.setState({ startDate, endDate, dateRange: [{ startDate: new Date(), endDate: new Date(), key: 'selection', color: "#E5F5FF" }],
        monthRange, startMonthRange, endMonthRange,  }, () => {
          let startMonthRange = (this.state.monthRange[0].month.number.toString().length > 1 ? this.state.monthRange[0].month.number : "0" + this.state.monthRange[0].month.number)  + "/" + this.state.monthRange[0].year.toString().substring(2, 4);
          let endMonthRange = (this.state.monthRange[1].month.number.toString().length > 1 ? this.state.monthRange[1].month.number : "0" + this.state.monthRange[1].month.number) + "/" + this.state.monthRange[1].year.toString().substring(2, 4);
          this.setState({ startMonthRange, endMonthRange,});
      });
    }
    else {
      let dtArry = this.state.displayDate.split("-");
      let dateRange = [{ startDate: new Date(), endDate: new Date(), key: 'selection', color: "#E5F5FF" }];
      let startDate = this.dateFormat(new Date());
      let endDate = this.dateFormat(new Date());
      let monthRange = [
        new DateObject(),
        new DateObject()
      ];
      let startMonthRange = '';
      let endMonthRange = '';
      let calendarActiveTab = "";
      if (this.state.displayDate.length > 13) {
        startDate = dtArry[0].toString().trim();
        endDate = dtArry[1].toString().trim();
        dateRange[0].startDate = new Date(dtArry[0].toString().trim());
        dateRange[0].endDate = new Date(dtArry[1].toString().trim());
        calendarActiveTab = "transaction";
        let $date = new Date(monthRange[0].month.number +"/01/"+ monthRange[0].year.toString().substring(2, 4));
        monthRange[0] = new DateObject($date);
      }
      else {
        startMonthRange = dtArry[0].toString().trim();
        endMonthRange = dtArry[1].toString().trim();

        for(let i = 0; i < dtArry.length ; i++) {
          let dtArr = dtArry[i].toString().trim().split("/");
          let $date = new Date(dtArr[0]+"/01/"+dtArr[1]);
          monthRange[i] = new DateObject($date);
        }
        calendarActiveTab = "accounting";
      }
      this.setState({ startDate, endDate, dateRange, monthRange, startMonthRange, endMonthRange, calendarActiveTab })
    }
    this.setState(prevState => ({
      isCalendarOpen: !prevState.isCalendarOpen
    }));
  }

  handleCustomModal = (type) => {
    if (type === "more") {
      this.setState(prevState => ({
        isCustomModalOpen: !prevState.isCustomModalOpen
      }));
    } else {
      this.setState({ chipClick: "" });
    }
    this.setState({updatedMultiCOAs: this.state.selectedMultiCOAs});
  }

  handleMoreFilter = (event: any) => {
    if (event === "Include Daily Activity Entries") {
      let chipList = [...this.state.chipList];
      if (this.state.searchData.filter(e => e.name === event).length === 0) {
        this.addMoreRequest({ name: "Include Daily Activity Entries", value: "Yes", value2: "" });
      }
      if (chipList.filter(e => e.name === event).length === 0) {
        chipList.push({ name: event, value: "" });
      }
      this.setState({ chipList });
    }
    else {
      this.setState({ isCustomModalOpen: true, isCustomModalType: event, selectedTransationType: "Select", txtMoreSearch: "", selectedMoreSearch: [],
        selectedLedgerType: "Select", toggleMatchActiveTab: "contains" 
      });
      if (event === "Vendor") {
        this.setState({ searchMoreList: [] }, () => {
          this.setState({ searchMoreList: this.state.VendorList })
        })
      } else if (event === "Customer No.") {
        this.setState({ searchMoreList: [] }, () => {
          this.setState({ searchMoreList: this.state.customerNoList })
        })
      } else if (event === "COA") {
        this.setState({ searchMoreList: [] }, () => {
          this.setState({ searchMoreList: this.state.coaList })
        })
      }
    }
  }

  onTypeAheadMoreChange(val) {
    let searchMoreList = this.state.searchMoreList.filter(e => e.label.toLowerCase() === val.toLowerCase())
    let moreSearch;
    if (searchMoreList.length > 0) {
      moreSearch = searchMoreList;
    } else {
      moreSearch = [{ id: -1, label: val }];
    }

    this.setState({ selectedMoreSearch: [] }, () => {
      this.setState({ selectedMoreSearch: moreSearch })
    });
  }

  typeheadMoreChange(e: any) {
    this.setState({ selectedMoreSearch: e });
  }

  handletransationType = (event: any) => {
    this.setState({ selectedTransationType: event });
  }

  handleLedgerType = (event: any) =>{
    this.setState({ selectedLedgerType: event });
  }

  handleAddChip = (event: any) => {
    let isValid = true;
    let value = "";
    if (event === "Transaction Type") {
      value = this.state.selectedTransationType;
      if (value !== "Select") {
        this.addMoreRequest({ name: event, value: this.state.selectedTransationType, value2: "" });
      } else {
        isValid = false;
      }

    } else if (event === "Ledger Type") {
      value = this.state.selectedLedgerType;
      if (value !== "Select") {
        this.addMoreRequest({ name: event, value: this.state.selectedLedgerType, value2: "" });
      } else {
        isValid = false;
      }

    } else if (event === "Customer No." || event === "Vendor") {
      let typeaheadmore = [...this.state.selectedMoreSearch]
      if (typeaheadmore.length > 0) {
        let searchMoreList :any =[];
        if(event === "Customer No.")
        {
         searchMoreList = this.state.searchMoreList.filter(e => (e.label.toLowerCase() === typeaheadmore[0].label.toLowerCase()))
        }
        else
        {
           searchMoreList = this.state.searchMoreList.filter(e => (e.label.toLowerCase() === typeaheadmore[0].label.toLowerCase() || e.id == typeaheadmore[0].label))
        }
        if (searchMoreList.length > 0) {
          value = searchMoreList[0].label;
          this.addMoreRequest({ name: event, value: searchMoreList[0].id, value2: searchMoreList[0].label });
        } else {
          value = typeaheadmore[0].label;
          if (event === "Vendor") {
            this.addMoreRequest({ name: event, value: typeaheadmore[0].id, value2: typeaheadmore[0].label });
          } else {
            this.addMoreRequest({ name: event, value: typeaheadmore[0].label, value2: typeaheadmore[0].label });
          }

        }
      } else {
        isValid = false;
      }

    } else if (event === "COA") {
      let updatedMultiCOAs = Object.assign([], JSON.parse(JSON.stringify(this.state.updatedMultiCOAs)));
      this.setState({selectedMultiCOAs: updatedMultiCOAs});
      value = updatedMultiCOAs.length > 0 ? updatedMultiCOAs.length === 1 ? updatedMultiCOAs[0].label : updatedMultiCOAs.length + " COAs Selected" : "";
      let idArray: any = [];
      let labelArray: any = [];
      updatedMultiCOAs.forEach((o: any) => idArray.push(o.id));
      updatedMultiCOAs.forEach((o: any) => labelArray.push(o.label.replace(o.description,'').trim()));
      if (updatedMultiCOAs.length > 0) {
        this.addMoreRequest({ name: event, value: idArray.toString(), value2: labelArray.toString() });
      } else {
        isValid = false;
      }
    }
    else if (event === "Exclude Unpaid Invoices & Unapproved Transactions") {
      value = this.state.selectedYesNo;
      this.addMoreRequest({ name: event, value: this.state.selectedYesNo, value2: "" });

    } else if (event === "Check No." || event === "Amount" || event === "Notes & Descriptions" || event === "Invoice No.") {
      value = this.state.txtMoreSearch;
      if (value.length > 0) {
        this.addMoreRequest({ name: event, value: this.state.txtMoreSearch, value2: "" });
      } else {
        isValid = false;
      }

    } else if (event === "Cleared Acct. Per.") {
      value = this.state.txtMoreSearch;
      if (value.length != 4 && value.length !== 5) {
        Utils.toastError("Cleared Act. Per Can not be blank and Date format should be : MM-YY", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
        return;
      }
      else {
        let dtArr = value.split("-");
        if (dtArr.length == 2 && (dtArr[0].length == 1 || dtArr[0].length == 2) && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && Number(dtArr[1]) > 0) {
          this.addMoreRequest({ name: event, value: value, value2: "" });
        } else {
          isValid = false;
          Utils.toastError("Cleared Act. Per Can not be blank and Date format should be : MM-YY", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          return;
        }
      }
    }

    if (!isValid) {
      value = "All"
      let searchData = Object.assign([], JSON.parse(JSON.stringify(this.state.searchData)));
      if (searchData.filter(e => e.name === event).length > 0) {
        const index = searchData.findIndex((x) => x.name === event);
        searchData.splice(index, 1);
      }
      this.setState({searchData}, () => {
        if (this.state.isSearched) {
          this.handleSearch("other");
        }
      })
    }

    let chipList = [...this.state.chipList];
    if (chipList.filter(e => e.name === event).length === 0) {
      chipList.push({ name: event, value: value });
    } else {
      const index = chipList.findIndex((e) => e.name === event);
      chipList[index].name = event;
      chipList[index].value = value;
    }
    this.setState({ chipList, isCustomModalOpen: false, chipClick: "" });
  }

  addMoreRequest(obj) {
    let obj1 = obj;
    let searchData = [...this.state.searchData];
    if (searchData.filter(e => e.name === obj.name).length > 0) {
      const index = searchData.findIndex((x) => x.name === obj.name);
      searchData[index].value = obj.value;
      searchData[index].value2 = obj.value2;
      searchData[index].type = obj.name === "Amount" || obj.name === "Check No." || obj.name === "Invoice No." 
      || obj.name === "Notes & Descriptions" || obj.name === "Customer No." ? this.state.toggleMatchActiveTab : "" ;
    } else {
      obj1.type = obj.name === "Amount" || obj.name === "Check No." || obj.name === "Invoice No." 
      || obj.name === "Notes & Descriptions" || obj.name === "Customer No." ? this.state.toggleMatchActiveTab : "" ;
      searchData.push(obj1);
    }
    this.setState({ searchData, isCustomModalOpen: false, chipClick: "" }, () => {
      if (this.state.isSearched) {
        this.handleSearch("other");
      }
    });
  }

  handleRemoveChip = (index) => {
    let chipList = [...this.state.chipList];
    let searchData = [...this.state.searchData];
    if(chipList[index].name.toLowerCase() === "coa") {
      this.setState({selectedMultiCOAs:[], updatedMultiCOAs: []});
    }
    const indexSearch = searchData.findIndex((x) => x.name === chipList[index].name);
    if (indexSearch !== -1) {
      searchData.splice(indexSearch, 1);
    }

    this.setState({ searchData }, () => {
      chipList.splice(index, 1);
      this.setState({ chipList }, () => {
        if (this.state.isSearched) {
          this.handleSearch("other");
        }
      });
    });
  }

  dateRangeSelect = (item) => {
    let startDate = this.dateFormat(new Date(item[0].startDate));
    let endDate = this.dateFormat(new Date(item[0].endDate));
    this.setState({ dateRange: item, startDate, endDate })
  }
  
  monthRangeSelect = (item) => {
    let startMonthRange = (item[0].month.number.toString().length > 1 ? item[0].month.number : "0" + item[0].month.number) + "/" + item[0].year.toString().substring(2, 4);
    let endMonthRange = item.length > 1 ? (item[1].month.number.toString().length > 1 ? item[1].month.number : "0" + item[1].month.number)  + "/" + item[1].year.toString().substring(2, 4) :
                                          (item[0].month.number.toString().length > 1 ? item[0].month.number : "0" + item[0].month.number)  + "/" + item[0].year.toString().substring(2, 4);
    this.setState({monthRange: item, startMonthRange, endMonthRange});
  }

  exportDateRangeSelect = (item) => {
    let exportStartDate = this.dateFormat(new Date(item[0].startDate));
    let exportEndDate = this.dateFormat(new Date(item[0].endDate));
    this.setState({ exportDateRange: item, exportStartDate, exportEndDate })
  }
  
  exportMonthRangeSelect = (item) => {
    let exportStartMonthRange = (item[0].month.number.toString().length > 1 ? item[0].month.number : "0" + item[0].month.number) + "/" + item[0].year.toString().substring(2, 4);
    let exportEndMonthRange = item.length > 1 ? (item[1].month.number.toString().length > 1 ? item[1].month.number : "0" + item[1].month.number)  + "/" + item[1].year.toString().substring(2, 4) :
                                          (item[0].month.number.toString().length > 1 ? item[0].month.number : "0" + item[0].month.number)  + "/" + item[0].year.toString().substring(2, 4);
    this.setState({exportMonthRange: item, exportStartMonthRange, exportEndMonthRange});
  }

  dateChange = (e, type) => {
    if (this.state.calendarActiveTab === "transaction" && this.state.exportCalendarActiveTab === "") {
      let dateRange = [...this.state.dateRange];
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;
      if (type === "start") {
        dateRange[0].startDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        startDate = e.target.value;
      } else if (type === "end") {
        dateRange[0].endDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        endDate = e.target.value;
      }
      this.setState({ dateRange, startDate, endDate });
    }
    else if (this.state.calendarActiveTab === "accounting" && this.state.exportCalendarActiveTab === "") {
      let monthRange = [...this.state.monthRange];
      let startMonthRange = this.state.startMonthRange;
      let endMonthRange = this.state.endMonthRange;
      let dtArr = e.target.value.split("/");
      if (type === "start") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          let $date = new Date(dtArr[0]+"/01/"+dtArr[1]);
          monthRange[0] = new DateObject($date);
        }
        else {
          monthRange[0] = "";
        }
        startMonthRange = e.target.value;
      } else if (type === "end") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          let $date = new Date(dtArr[0]+"/01/"+dtArr[1]);
          monthRange[1] = new DateObject($date);
        }
        else {
          monthRange[1] = "";
        }
        endMonthRange = e.target.value;
      }
      this.setState({ monthRange, startMonthRange, endMonthRange });
    }
    else if (this.state.exportCalendarActiveTab === "exportTransaction") {
      let exportDateRange = [...this.state.exportDateRange];
      let exportStartDate = this.state.exportStartDate;
      let exportEndDate = this.state.exportEndDate;
      if (type === "start") {
        exportDateRange[0].startDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        exportStartDate = e.target.value;
      } else if (type === "end") {
        exportDateRange[0].endDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        exportEndDate = e.target.value;
      }
      this.setState({ exportDateRange, exportStartDate, exportEndDate });
    }
    else if (this.state.exportCalendarActiveTab === "exportAccounting") {
      let exportMonthRange = [...this.state.exportMonthRange];
      let exportStartMonthRange = this.state.exportStartMonthRange;
      let exportEndMonthRange = this.state.exportEndMonthRange;
      let dtArr = e.target.value.split("/");
      if (type === "start") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          let $date = new Date(dtArr[0]+"/01/"+dtArr[1]);
          exportMonthRange[0] = new DateObject($date);
        }
        else {
          exportMonthRange[0] = "";
        }
        exportStartMonthRange = e.target.value;
      } else if (type === "end") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          let $date = new Date(dtArr[0]+"/01/"+dtArr[1]);
          exportMonthRange[1] = new DateObject($date);
        }
        else {
          exportMonthRange[1] = "";
        }
        exportEndMonthRange = e.target.value;
      }
      this.setState({ exportMonthRange, exportStartMonthRange, exportEndMonthRange });
    }
  }

  dateBlur = (e, type) => {
    if (this.state.calendarActiveTab === "transaction" && this.state.exportCalendarActiveTab === "") {
      let dateRange = [...this.state.dateRange];
      let startDate = this.state.startDate;
      let endDate = this.state.endDate;
      if (type === "start") {
        dateRange[0].startDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        startDate = this.dateFormat(e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date());
        this.setState({ dateRange, startDate })
      } else if (type === "end") {
        dateRange[0].endDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
        endDate = this.dateFormat(e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date());
        this.setState({ dateRange, endDate })
      }
      if(dateRange[0].startDate > dateRange[0].endDate) {
        let temp = dateRange[0].startDate;
        dateRange[0].startDate = dateRange[0].endDate;
        dateRange[0].endDate = temp;
        let temp2 = startDate;
        startDate = endDate;
        endDate = temp2;
        this.setState({ dateRange, startDate, endDate })
      }

    }
    else if (this.state.calendarActiveTab === "accounting" && this.state.exportCalendarActiveTab === "") {
      let monthRange = [...this.state.monthRange];
      let startMonthRange = this.state.startMonthRange;
      let endMonthRange = this.state.endMonthRange;
      let dtArr = e.target.value.split("/");
      if (type === "start") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          // Do this
        }
        else {
          monthRange[0] = new DateObject();
          let $date = new Date(monthRange[0].month.number +"/01/"+ monthRange[0].year.toString().substring(2, 4));
          monthRange[0] = new DateObject($date);
          startMonthRange = (monthRange[0].month.number.toString().length > 1 ? monthRange[0].month.number : "0" + monthRange[0].month.number)  + "/" + monthRange[0].year.toString().substring(2, 4);
          this.setState({ monthRange, startMonthRange });
        }
      } else if (type === "end") {
        if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
          // Do this
        }
        else {
          monthRange[1] = new DateObject();
          let $date = new Date(monthRange[1].month.number +"/01/"+ monthRange[1].year.toString().substring(2, 4));
          monthRange[1] = new DateObject($date);
          endMonthRange = (monthRange[1].month.number.toString().length > 1 ? monthRange[1].month.number : "0" + monthRange[1].month.number)  + "/" + monthRange[1].year.toString().substring(2, 4);
          this.setState({ monthRange, endMonthRange });
        }
    }
    if(monthRange[0]>monthRange[1]){
      let temp = monthRange[0];
      monthRange[0] = monthRange[1];
      monthRange[1] = temp;
      let temp2 = startMonthRange;
      startMonthRange = endMonthRange;
      endMonthRange = temp2;
      this.setState({ monthRange, startMonthRange, endMonthRange })
    }
  }
  else if (this.state.exportCalendarActiveTab === "exportTransaction") {
    let exportDateRange = [...this.state.exportDateRange];
    let exportStartDate = this.state.exportStartDate;
    let exportEndDate = this.state.exportEndDate;
    if (type === "start") {
      exportDateRange[0].startDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
      exportStartDate = this.dateFormat(e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date());
      this.setState({ exportDateRange, exportStartDate })
    } else if (type === "end") {
      exportDateRange[0].endDate = e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date();
      exportEndDate = this.dateFormat(e.target.value.length > 0 ? ((new Date(e.target.value)).toString() !== "Invalid Date") ? new Date(e.target.value) : new Date() : new Date());
      this.setState({ exportDateRange, exportEndDate })
    }
    if(exportDateRange[0].startDate > exportDateRange[0].endDate) {
      let temp = exportDateRange[0].startDate;
      exportDateRange[0].startDate = exportDateRange[0].endDate;
      exportDateRange[0].endDate = temp;
      let temp2 = exportStartDate;
      exportStartDate = exportEndDate;
      exportEndDate = temp2;
      this.setState({ exportDateRange, exportStartDate, exportEndDate })
    }
  }
  else if (this.state.exportCalendarActiveTab === "exportAccounting") {
    let exportMonthRange = [...this.state.exportMonthRange];
    let exportStartMonthRange = this.state.exportStartMonthRange;
    let exportEndMonthRange = this.state.exportEndMonthRange;
    let dtArr = e.target.value.split("/");
    if (type === "start") {
      if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
        // Do this
      }
      else {
        exportMonthRange[0] = new DateObject();
        let $date = new Date(exportMonthRange[0].month.number +"/01/"+ exportMonthRange[0].year.toString().substring(2, 4));
        exportMonthRange[0] = new DateObject($date);
        exportStartMonthRange = (exportMonthRange[0].month.number.toString().length > 1 ? exportMonthRange[0].month.number : "0" + exportMonthRange[0].month.number)  + "/" + exportMonthRange[0].year.toString().substring(2, 4);
        this.setState({ exportMonthRange, exportStartMonthRange });
      }
    } else if (type === "end") {
      if(e.target.value.length == 5 && dtArr[0].length == 2 && dtArr[1].length == 2 && Number(dtArr[0]) > 0 && Number(dtArr[0]) <= 12 && (new Date(dtArr[0]+"/01/"+dtArr[1]).toString() !== "Invalid Date")) {
        // Do this
      }
      else {
        exportMonthRange[1] = new DateObject();
        let $date = new Date(exportMonthRange[1].month.number +"/01/"+ exportMonthRange[1].year.toString().substring(2, 4));
        exportMonthRange[1] = new DateObject($date);
        exportEndMonthRange = (exportMonthRange[1].month.number.toString().length > 1 ? exportMonthRange[1].month.number : "0" + exportMonthRange[1].month.number)  + "/" + exportMonthRange[1].year.toString().substring(2, 4);
        this.setState({ exportMonthRange, exportEndMonthRange });
      }
    }
    if(exportMonthRange[0]>exportMonthRange[1]){
      let temp = exportMonthRange[0];
      exportMonthRange[0] = exportMonthRange[1];
      exportMonthRange[1] = temp;
      let temp2 = exportStartMonthRange;
      exportStartMonthRange = exportEndMonthRange;
      exportEndMonthRange = temp2;
      this.setState({ exportMonthRange, exportStartMonthRange, exportEndMonthRange })
    }
  }
}

  amountValidation = (e, category) => {
    if (category == "Amount" && e.target.value.length != 0 ) {
      let amt = Utils.removeInvaildCharFromAmountNonMinus(e.target.value);
      amt = amt.length == 0 ? "" : amt.split('.').length > 1 ? amt.split('.')[1].length == 0 ? amt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : amt.split('.')[1].length == 1 ? Number(amt).toFixed(1).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : Number(amt).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : Number(amt).toFixed().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      this.setState({ selectedSearch: amt });
      this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: Utils.removeInvaildCharFromAmountNonMinus(amt), value2: "" });
    }
    if(e.target.value.length != 0) {
      this.handleTypeAheadBlur(e);
    }
  }

  dateSave = () => {
    if(this.state.calendarActiveTab === "transaction") {
      let dateRange = [...this.state.dateRange];
      let start = this.dateFormat(dateRange[0].startDate)
      let end = this.dateFormat(dateRange[0].endDate)
      let displayDate = start + " - " + end;
      this.setState({ displayDate })

      let searchData = [...this.state.searchData];
      if (searchData.filter(e => e.name === "date").length > 0) {
        const index = searchData.findIndex((x) => x.name === "date");
        searchData[index].value = start;
        searchData[index].value2 = end;
      } else {
        searchData.push({ name: "date", value: start, value2: end });
      }
      if (searchData.filter((x) => x.name === "accperiod").length > 0) {
        const index = searchData.findIndex((x) => x.name === "accperiod");
        searchData.splice(index, 1);
      }

      this.setState({ searchData, isCalendarOpen: false }, () => {
        if (this.state.isSearched) {
          this.handleSearch("other");
        }
      });
    }
    else if (this.state.calendarActiveTab === "accounting") {
      let {startMonthRange, endMonthRange, } = this.state;
      let displayDate = startMonthRange + " - " + endMonthRange;
      this.setState({ displayDate });

      let searchData = [...this.state.searchData];
      if (searchData.filter(e => e.name === "accperiod").length > 0) {
        const index = searchData.findIndex((x) => x.name === "accperiod");
        searchData[index].value = startMonthRange;
        searchData[index].value2 = endMonthRange;
      } else {
        searchData.push({ name: "accperiod", value: startMonthRange, value2: endMonthRange });
      }
      if (searchData.filter((x) => x.name === "date").length > 0) {
        const index = searchData.findIndex((x) => x.name === "date");
        searchData.splice(index, 1);
      }
      this.setState({ searchData, isCalendarOpen: false }, () => {
        if (this.state.isSearched) {
          this.handleSearch("other");
        }
      });
    }
  }

  dateFormat(date) {
    let datee = new Date(date);
    let calenderYeare = datee.getFullYear().toString().substr(2, 4);
    let calenderDatee = datee.getDate() > 9 ? datee.getDate() : 0 + "" + datee.getDate();
    let calenderMonthe = datee.getMonth() + 1 > 9 ? datee.getMonth() + 1 : 0 + "" + (datee.getMonth() + 1);
    let tempDatee = calenderMonthe + "/" + calenderDatee + "/" + calenderYeare;
    return tempDatee;
  }

  handleDDL(value) {
    this.setState({ selectedYesNo: value });
  }

  txtMoreChange(e,type) {
    if (type !== "Cleared Acct. Per.") {
      this.setState({ txtMoreSearch: e.target.value });
    }
    else {
      const _formattedValue = Utils.addHypenInInputDateFormatMMYY(e.target.value,this.state.txtMoreSearch);
      if (_formattedValue === "invalid") {
        return;
      } else {
        this.setState({ txtMoreSearch: _formattedValue });
      }
    }
  }

  handleChange = (e: { target: { value: string } }) => {
    const updatedList = Object.assign([], JSON.parse(JSON.stringify(this.state.allehidData))).filter((item: any) => {
      return (
        item.ehidName.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1
      );
    });
    this.setState({ allehid: updatedList, inputValue: e.target.value });
  }

  handleTypeAheadBlur = (e) => {
    let searchData = [...this.state.searchData];
    if (this.state.selectedSearch.length > 0 && this.state.displayDate === "Date") {
      let ref: any = e.relatedTarget;
      let today = new Date();
      let previousYrDate = new Date();
      previousYrDate.setFullYear(previousYrDate.getFullYear() - 1);
      let formattedToday = this.dateFormat(today);
      let formattedPreviousYrDate = this.dateFormat(previousYrDate);
      let displayDate = formattedPreviousYrDate + " - " + formattedToday;
      if (searchData.filter(e => e.name === "date").length > 0) {
        const index = searchData.findIndex((x) => x.name === "date");
        searchData[index].value = formattedPreviousYrDate;
        searchData[index].value2 = formattedToday;
      } else {
        searchData.push({ name: "date", value: formattedPreviousYrDate, value2: formattedToday });
      }
      this.setState({searchData, displayDate, },() => {
        if (ref === this.searchBtnRef.current) {
          this.handleSearch("search");
        }
      });
    }
  }

  handleSearch = (e) => {
    let searchData = [...this.state.searchData];
    let chipList = [...this.state.chipList];
    if(e === "search") {
        if (this.state.selectCategories.categoriesName === "COA" || this.state.selectCategories.categoriesName === "Amount" || this.state.selectCategories.categoriesName === "Notes & Descriptions") {
          if (searchData.filter(e => e.name === "Include Daily Activity Entries").length === 0) {
            searchData.push({ name: "Include Daily Activity Entries", value: "Yes", value2: "", type: "" });
          }
          if (chipList.filter(e => e.name === "Include Daily Activity Entries").length === 0) {
            chipList.push({ name: "Include Daily Activity Entries", value: "" });
          }
        }
      if (this.state.displayDate !== "Date") {
        this.setState({isConfirmationModal: false, searchData, chipList, }, () => {
          this.handleLoadData(e);
        });
      } else {
        this.setState({isConfirmationModal: true, searchData, chipList, }, () => {
          this.handleLoadData(e);
        });
      }
    }
    else if (e === "yes") {
      this.setState({isConfirmationModal: false}, () => {
        this.handleLoadData(e);
      });
    }
    else {
      this.handleLoadData(e);
    }
  }

  rejectConfirmation = () => {
    this.setState({isConfirmationModal: false});
  }

  handleLoadData = (e) =>{
    let searchData = [...this.state.searchData];
    if(e === "other" || e === "yes" || (!this.state.isConfirmationModal && e === "search")) {
      this.setState({ loader: true, isSearched: true, searcResult: [],isColumnChange:false, isSubVendorBanner: false, isSearchEHIDFlagBanner: false, },()=>{
        this.setState({isColumnChange:true })
      });
      if (searchData.filter((x) => x.name.toLowerCase() === "coa").length > 0 && !this.state.isRegularOrSplitClicked) {
        searchData.map((items) => (items["viewType"] = "split"));
      }
      else if (searchData.filter((x) => x.name.toLowerCase() === "coa").length > 0 && this.state.isRegularOrSplitClicked) {
        searchData.map((items) => (items["viewType"] = this.state.tableActiveTab));
      }
      else {
        searchData.map((items) => (items["viewType"] = this.state.tableActiveTab));
      }
      let storage = JSON.parse(localStorage.getItem("storage")!);
      let tenantID = storage === null ? 0 : storage.tenantID;
      searchData.map((items) => (items["TenantID"] = tenantID));
      let request: any = {};
      request.SearchRequestParm = searchData;
      accountService.AccountSearchResult(request)
        .then(async (result: any | null) => {
          if (result !== null) {
            this.setState({ searcResult: result }, () => {
              this.setState({ loader: false, searchStart: true, });
              if(this.state.searcResult.length > 0) {
                this.setState({ isSubVendorBanner: this.state.searcResult[0].isSubvendorExist === "Yes" ? true : false, isSearchEHIDFlagBanner: this.state.searcResult[0].searchEHIDFlag.toLowerCase() === "yes" ? true : false, });
              }
            });
          }
          if(searchData.filter((x) => x.name.toLowerCase() === "coa").length > 0 && !this.state.isRegularOrSplitClicked) {
            this.setState({ tableActiveTab: "split", isRegularOrSplitClicked: false, }, () => {
              this.toggleTableSelect(this.state.tableActiveTab);
            });
          }
          else {
            this.setState({ isRegularOrSplitClicked: false, }, () => {
              this.toggleTableSelect(this.state.tableActiveTab);
            });
          }
          if (result.length === 0) {
            this.setState({ loader: false, searcResult: [], searchStart: true });
          }
          resolve();
        })
        .catch((err: any) => {
          this.setState({ loader: false });
          Utils.toastError(err.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
          reject();
        });
    }
  }


  onHandleColumn = (e: any, selitem: any, index: any) => {

    let data = Object.assign([], JSON.parse(JSON.stringify(this.state.tableColumnList)));
    data[index].isChecked = e.target.checked;
    let { columns } = this.state;
    columns[index].hidden = data[index].isChecked ? false : true;
    this.setState({ tableColumnList: data, columns, isColumnChange: false }, () => {
      this.setState({ isColumnChange: true })
    })
  }

  densitySelect = (event: any) => {
    this.setState({ densityName: event.eventName });
  }

  rowEvents = {
    onClick: (e: any, newRow: any, rowIndex: any) => {
      this.setState({ isSlideOut: false, isTransferSlideOut: false, isTRSideOut: false, isCCSlideout: false, })
      const uniqueNo = newRow.uniqueno;
      const etype = newRow.etype;
      let backhid = newRow.backhid;
      let pageType = this.getEtype(etype, 'child');
      let acctType1 = this.getAccttype(etype);
      let acctType = newRow.type === "Operating" ? "O" : newRow.type === "Payroll" ? "P" : newRow.type === "Miscellaneous" ? "M" : "";
      let registerRequest1 = { ...this.state.registerRequest };
      registerRequest1.oprID = Number(newRow.oprid);

      if (etype.toLowerCase() === 'Invoice'.toLowerCase()) {
        let registerRequest = {} as any;
        registerRequest.UniqueNo = uniqueNo;
        registerRequest.oprID = Number(newRow.oprid);
        registerRequest.acctType = acctType1;
        this.setState({
          trUniqueNo: uniqueNo, pageType: pageType, sildeoutHid: Number(backhid),
          registerRequest
        }, () => {
          this.setState({ isSlideOut: true });
        });

      } else if (etype.toLowerCase() === 'Deposit'.toLowerCase()
        || etype.toLowerCase() === 'Misc'.toLowerCase()
        || etype.toLowerCase() === 'MiscDeposit'.toLowerCase()
        || etype.toLowerCase() === 'PayrollDeposit'.toLowerCase()
        || etype.toLowerCase() === 'PayrollWithdrawal'.toLowerCase()
        || etype.toLowerCase() === 'WithDrawal'.toLowerCase()
      ) {

        let registerRequest = {} as any;
        registerRequest.UniqueNo = uniqueNo;
        registerRequest.oprID = Number(newRow.oprid);
        registerRequest.acctType = acctType1;
        this.setState({
          trUniqueNo: uniqueNo, pageType: pageType, sildeoutHid: Number(backhid),
          registerRequest
        }, () => {
          this.setState({ isSlideOut: true });
        });

      } else if (etype.toLowerCase() === 'Journal'.toLowerCase() && newRow.vendor.toLowerCase() !== "XXX COA-WISE PAYROLL IMPORT XXX".toLowerCase()) {
        let JERequest = {} as any;
        JERequest.UniqueNo = uniqueNo;
        this.setState({
          JERequest, pageType: "Journal", sildeoutHid: Number(backhid), isTRSideOut: true
        })

      } else if (etype.toLowerCase() === 'MiscTransfer'.toLowerCase()
        || etype.toLowerCase() === 'PayrollTransfer'.toLowerCase()
        || etype.toLowerCase() === 'Transfer'.toLowerCase()
      ) {
        let transferRequest = {} as any;
        transferRequest.acctType = acctType;
        transferRequest.hasRecouncil = false;
        this.setState({
          trUniqueNo: uniqueNo, registerRequest: registerRequest1, transferRequest,
          isTransferSlideOut: true, sildeoutHid: backhid, sildeoutCode: Number(backhid)
        })
      } else if (etype.toLowerCase() === 'CreditCardWithdrawal'.toLowerCase()
        || etype.toLowerCase() === 'CreditCardDeposit'.toLowerCase()) {
        let cctype = etype.toLowerCase() === 'CreditCardWithdrawal'.toLowerCase() ? "CCDEBIT" : "CCCREDIT";
        this.setState({
          selectedRow: {}, ccSlideType: cctype, trUniqueNo: uniqueNo, registerRequest: registerRequest1,
          vid: "0", oprId: Number(newRow.oprid), isCCSlideout: true, sildeoutHid: backhid, sildeoutCode: ""
        })
      } else if (etype.toLowerCase() === "DepositEntry".toLowerCase()) {
        if (newRow.vendor?.toLowerCase()?.includes("adjustment")) {
          Utils.toastError("Adjustment/Commission entries cannot be opened.", {
            position: toast.POSITION.BOTTOM_RIGHT,
          });
        } else {
          this.setState({ sildeoutHid: Number(backhid) }, () => {
            if (this.state.isDailyActivityClickable) {
              this.showDailyActivitySlideout(newRow);
            } else {
              Utils.toastError("Daily entries cannot be opened from here.", {
                position: toast.POSITION.BOTTOM_RIGHT,
              });
            }
          })
        }
      } else if (etype.toLowerCase() === "Journal".toLowerCase() && newRow.vendor.toLowerCase() === "XXX COA-WISE PAYROLL IMPORT XXX".toLowerCase()) {
        Utils.toastError("Payroll entries cannot be opened.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else if (etype.toLowerCase() === "NewPayroll".toLowerCase() || etype.toLowerCase() === "PayrollCheckManual".toLowerCase()) {
        Utils.toastError("Payroll entries cannot be opened.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else if (etype.toLowerCase() === "reconcileadjustment") {
        Utils.toastError("Adjustment/Commission entries cannot be opened.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      } else {
        Utils.toastError("These entries cannot be opened.", {
          position: toast.POSITION.BOTTOM_RIGHT,
        });
      }
    }
  }

  getEtype(mtype, rowType) {
    let etype = '';
    etype = registersevice.getEtype(mtype, rowType);
    return etype;
  }

  getAccttype(mtype) {
    let accttype = '';
    accttype = registersevice.getAccttype(mtype);
    return accttype;
  }


  hideSlideOut = (isSave) => {
    if (isSave) {
      this.handleSearch("other");
    }
    this.setState({
      isSlideOut: false,
      isTransferSlideOut: false,
      isTRSideOut: false
    })
  }

  hideTrSlideOut(hasEvent) {
    if (hasEvent) {
      this.handleSearch("other");
    }
    this.setState({
      isTransferSlideOut: false
    })
  }

  hideCCSlideOut = (isSave) => {
    if (isSave) {
      this.handleSearch("other");
    }
    this.setState({ isCCSlideout: false });
  }



  OpenInvoiceSlideOut = (e, newrow, rowIndex, rowType) => {
    if (!this.state.isBgBlue) {
      let row: any = {};
      row.hid = newrow.hotelid;
      row.etype = "Invoice";
      row.vendor = newrow.vendor;
      row.backHIDCode = newrow.lettercode;
      row.vid = newrow.vid;
      row.oprId = newrow.oprID;
      row.uniqueno = newrow.uniqueno;
      row.checkno = newrow.ckno;
      row.series = newrow.series;
      row.invPostFix = newrow.postFix;
      row.groupID = newrow.groupID;
      this.hideSlideOut(false);
      this.handlerowEvents(e, row, rowIndex, rowType);
    }
  }

  handlerowEvents = (e: any, row: any, rowIndex: any, rowType) => {
    let registerRequest1 = { ...this.state.registerRequest }
    let etype = '';
    etype = this.getEtype(row.etype, rowType);
    this.setState({
      selectedRow: row, pageType: etype,
      trUniqueNo: row.uniqueno, registerRequest: registerRequest1, vid: row.vid, oprId: row.oprId,
      isSlideOut: true, sildeoutHid: row.hid, sildeoutCode: row.backHIDCode
    })
  }

  handleOutSideDateClick = (controll) => {
    if(!this.state.isSlideOut)
    {
    if (controll === "calendar") {
      this.setState({ isCalendarOpen: false });
    } else if (controll === "customModal") {
      this.setState({ isCustomModalOpen: false });
    }
  }
  };

  handleOutSideChipClick = (index) => {
    if(!this.state.isSlideOut)
    {
      if (index === this.state.index) {
        this.setState({ chipClick: "" });
      }
    }
  };

  onchipClick = (item, index) => {
    this.setState({
      chipClick: item.name,
      index,
      selectedTransationType: "Select",
      selectedMoreSearch: [],
      txtMoreSearch: "",
      selectedLedgerType: "Select",
      toggleMatchActiveTab: "contains",
    })
  }

  saveDefaultColumn = (): void => {
    let tableColumnList = Object.assign([], JSON.parse(JSON.stringify(this.state.tableColumnList)));
    let selectedColumns: any = [];
    tableColumnList.map(item => {
      if (item.isChecked) {
        selectedColumns.push(item.id)
      }
    })
    const laborSaveAsDefaultdtos: any[] = [];
    laborSaveAsDefaultdtos.push({
      fieldName: "column",
      fieldValue: this.state.tableActiveTab + "_" + this.state.densityName + "_" + (selectedColumns).toString(),
      pageName: "AccountSearch",
    });

    laborPerformance.saveDefaultViewProperties(laborSaveAsDefaultdtos)
      .then(async (result: any | null) => {
        if (result != null) {
          if (result.message === "Success") {
            toast.success(result?.result?.message, { position: toast.POSITION.BOTTOM_RIGHT });
          }
        }
      })
      .catch((error) => {
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
        this.setState({ showLoader: false });
      });
  };



  getDefaultColumn = () => {
    let { tableColumnList, columns } = this.state;

    let data = Object.assign([], JSON.parse(JSON.stringify(this.state.tableColumnList)));
    laborPerformance.getDefaultViewProperties("AccountSearch")
      .then(async (response: any | null) => {
        if (response?.length > 0) {
          let defaultSetting = response[0].fieldValue.split("_");
          let defaultView = defaultSetting[0].toString();
          let defaultdensity = defaultSetting[1].toString();
          let defaultColumn = defaultSetting[2].toString();
          let resData = defaultColumn.split(",");
          tableColumnList.map(item => { item.isChecked = false })
          resData.forEach(ritm => {
            tableColumnList.map(item => {
              if (item.id === ritm) {
                item.isChecked = true;
              }
              if (defaultView === "regular" && (item.id === "coaName" || item.id === "description" || item.id === "subvendor" || item.id === "project")) {
                item.disabled = true;
              }
              else {
                item.disabled = false;
              }


            })
          })
          this.setState({ densityName: defaultdensity, tableActiveTab: defaultView, columns, tableColumnList }, () => {
            tableColumnList.map((item, idx) => {
              columns[idx].hidden = tableColumnList[idx].isChecked ? false : true;
            });

            if (defaultView === "regular") {

              tableColumnList.map((item, inx) => {
                if (item.id === "coaName" || item.id === "description" || item.id === "subvendor" || item.id === "project") {
                  columns[inx].hidden = true;
                }
                else if (item.id === "payment") {
                  columns[inx].dataField = 'transamount';
                }
                else if (item.id === "deposit") {
                  columns[inx].dataField = 'depositTotal';
                }
              })
            }
            else {
              tableColumnList.map((item, inx) => {
                if (item.id === "coaName" || item.id === "subvendor" || item.id === "project") {
                  columns[inx].hidden = tableColumnList[inx].isChecked ? false : true;
                }
                else if (item.id === "payment" || item.id === "deposit") {
                  columns[inx].dataField = item.id;
                }
              })
            }

            this.setState({ columns, isColumnChange: false }, () => {
              this.setState({ isColumnChange: true })
            })

          });
        } else {
          this.setState({ tableColumnList: data }, () => {

            if (this.state.tableActiveTab === "regular") {

              data.map((item, inx) => {
                if (item.id === "coaName" || item.id === "description" || item.id === "subvendor") {
                  columns[inx].hidden = true;
                }
                else if (item.id === "payment") {
                  columns[inx].dataField = 'transamount';
                }
                else if (item.id === "deposit") {
                  columns[inx].dataField = 'depositTotal';
                }
              })
            }
            else {
              data.map((item, inx) => {
                if (item.id === "coaName" || item.id === "subvendor") {
                  columns[inx].hidden = data[inx].isChecked ? false : true;
                }
                else if (item.id === "payment" || item.id === "deposit") {
                  columns[inx].dataField = item.id;
                }
              })
            }

            this.setState({ columns, isColumnChange: false }, () => {
              this.setState({ isColumnChange: true })
            })

          })
        }
      })
      .catch((error) => {
        this.setState({ tableColumnList: data }, () => {

        })
        Utils.toastError(error.message, { position: toast.POSITION.BOTTOM_RIGHT });
      });
  }

  getExport = () => {
    exportDataSet = [];

    let dateObj = new Date();

    let objmonth = (dateObj.getMonth() + 1) < 10 ? "0" + (dateObj.getMonth() + 1).toString() : (dateObj.getMonth() + 1).toString();
    let objdate = (dateObj.getUTCDate()) < 10 ? "0" + (dateObj.getUTCDate()).toString() : (dateObj.getUTCDate()).toString();
    let objHr = (dateObj.getHours()) < 10 ? "0" + (dateObj.getHours()).toString() : (dateObj.getHours()).toString();
    let objMM = (dateObj.getMinutes()) < 10 ? "0" + (dateObj.getMinutes()).toString() : (dateObj.getMinutes()).toString();
    let objSS = (dateObj.getSeconds()) < 10 ? "0" + (dateObj.getSeconds()).toString() : (dateObj.getSeconds()).toString();

    
    let excelfileName = "Search-" + (dateObj.getUTCFullYear().toString().substring(2, 4))
      + "-" + objmonth + "" + objdate
      + " " + objHr.toString() + "." + objMM.toString() + "." + objSS.toString();



    let tableData = Object.assign([], JSON.parse(JSON.stringify(this.state.searcResult)));
    let isLetterCode = this.state.tableColumnList.filter(item => item.id === "lettercode" && item.isChecked === true).length > 0;
    let isdate = this.state.tableColumnList.filter(item => item.id === "date" && item.isChecked === true).length > 0;
    let isaccountPeriod = this.state.tableColumnList.filter(item => item.id === "accountPeriod" && item.isChecked === true).length > 0;
    let isduedate = this.state.tableColumnList.filter(item => item.id === "duedate" && item.isChecked === true).length > 0;
    let isvendor = this.state.tableColumnList.filter(item => item.id === "vendor" && item.isChecked === true).length > 0;
    let isSubvendor = this.state.tableColumnList.filter(item => item.id === "subvendor" && item.isChecked === true).length > 0;
    let isinvoiceNo = this.state.tableColumnList.filter(item => item.id === "invoiceNo" && item.isChecked === true).length > 0;
    let isinvdate = this.state.tableColumnList.filter(item => item.id === "invdate" && item.isChecked === true).length > 0;
    let iscoaName = this.state.tableColumnList.filter(item => item.id === "coaName" && item.isChecked === true).length > 0;
    let isckno = this.state.tableColumnList.filter(item => item.id === "ckno" && item.isChecked === true).length > 0;
    let ispayment = this.state.tableColumnList.filter(item => item.id === "payment" && item.isChecked === true).length > 0;
    let isdeposit = this.state.tableColumnList.filter(item => item.id === "deposit" && item.isChecked === true).length > 0;
    let istranstotal = this.state.tableColumnList.filter(item => item.id === "transtotal" && item.isChecked === true).length > 0;
    let istransamount = this.state.tableColumnList.filter(item => item.id === "transamount" && item.isChecked === true).length > 0;
    let iscl = this.state.tableColumnList.filter(item => item.id === "cl" && item.isChecked === true).length > 0;
    let isinternalnotes = this.state.tableColumnList.filter(item => item.id === "internalnotes" && item.isChecked === true).length > 0;
    let isDescription = this.state.tableColumnList.filter(item => item.id === "description" && item.isChecked === true).length > 0;
    let isProject = this.state.tableColumnList.filter(item => item.id === "project" && item.isChecked === true).length > 0;
    if (this.state.tableActiveTab === "regular") {
      isDescription = false;
      iscoaName = false;
      isSubvendor = false;
      isProject = false;
      tableData = tableData.filter(e => e.viewType === 1)
    } else {
      tableData = tableData.filter(e => e.viewType === 2)
    }
let dateFormat="MM/DD/YY";
    tableData.forEach(item => {
      let row: any = {};
      isLetterCode && (row["EHID"] = item.lettercode);
      isdate && (row["Date"] = moment(item.date).format(dateFormat));
      isaccountPeriod && (row["Act. Per"] = moment(item.period).format(dateFormat));
      isduedate && (row["Due Date"] = item.duedate ==="" ? "" : moment(item.duedate).format(dateFormat));
      isvendor && (row["Vendor"] = item.vendor);
      isSubvendor && (row["Subvendor"] = item.subvendor);
      isinvoiceNo && (row["Inv. No."] = item.invoiceNo);
      isinvdate && (row["Inv. Date"] =item.billdate ==="" ? "" : moment(item.billdate).format(dateFormat));
      iscoaName && (row["COA"] = item.coa);
      iscoaName && (row["COA Name"] = item.coaName);
      isckno && (row["Check No."] = item.ckno);
      ispayment && (row["Payment"] = this.state.tableActiveTab === "regular" ? item.transamount : item.payment);
      isdeposit && (row["Deposit"] = this.state.tableActiveTab === "regular" ? item.depositTotal : item.deposit);
      istranstotal && (row["Total"] = item.transtotal);
      istransamount && (row["Ledger"] = item.acctName);
      iscl && (row["CL"] = item.cl.length === 0 ? "" : " " + item.cl);
      isDescription && (row["Description"] = item.description);
      isinternalnotes && (row["Notes"] = item.internalnotes);
      isProject && (row["Project"] = item.project);
      exportDataSet.push(row);
    })
    this.setState({ exportData: exportDataSet, excelfileName: excelfileName }, () => {
      let tempLink = document.getElementById("btnexport1") as any;
      tempLink.click();
    })


  }

  resetFilters = () => {
    
    let allItemList = Object.assign([], JSON.parse(JSON.stringify(this.state.allehid)));
    allItemList.forEach((element) => {
      element.isChecked = false;
    });

    this.setState({
      searchList: [], selectedSearch: [], searchData: [],
      displayDate: "Date", chipList: [], allehid: allItemList, isSearched: false, searchStart: false, 
      inputValue: "", calendarActiveTab: "transaction",
      selectCategories: { categoriesName: "Vendor", eventName: "vendor", dbName: "vid" },
      toggleMatchActiveTab: 'contains', isExactMatchChecked: false, isConfirmationModal: false,
      isSearchEHIDFlagBanner: false, isSubVendorBanner: false,
      selectedMultiCOAs: [], updatedMultiCOAs: [],
    }, () => {
      this.bindEHID();
      this.AccountSearchFilterALLType();
      this.getDefaultColumn();
    })

  }

  clearDateFilter = () => {
    let searchData = [...this.state.searchData];
    if (searchData.filter((x) => x.name === "accperiod").length > 0) {
        const index = searchData.findIndex((x) => x.name === "accperiod");
        searchData.splice(index, 1);
      }
	  
	  if (searchData.filter((x) => x.name === "date").length > 0) {
        const index = searchData.findIndex((x) => x.name === "date");
        searchData.splice(index, 1);
      }
	  
	  this.setState({ searchData, displayDate: "Date", }, () => {
        if (this.state.isSearched) {
          this.handleSearch("other");
        }
      });
  }

  onSelectCOAs = (selectedList, filterType) => {
    if (filterType === "main") {
      if (this.state.selectedMultiCOAs !== selectedList) {
        this.setState({ selectedMultiCOAs: selectedList, selectedSearch: selectedList }, () => {
            if (this.state.selectedMultiCOAs.length > 0) {
              let idArray: any = [];
              let labelArray: any = [];
              this.state.selectedMultiCOAs.forEach((o: any) => idArray.push(o.id));
              this.state.selectedMultiCOAs.forEach((o: any) => labelArray.push(o.label.replace(o.description,'').trim()));
              this.addCategoryRequest({ name: this.state.selectCategories.dbName, value: idArray.toString(), value2: labelArray.toString() });
            } else {
              let searchData = [...this.state.searchData];
              if (searchData.filter((x) => x.name === this.state.selectCategories.dbName).length > 0) {
                const index = searchData.findIndex((x) => x.name === this.state.selectCategories.dbName);
                searchData.splice(index, 1);
              }
              this.setState({ searchData });
            }
        });
      }
    }
    else {
      if (this.state.updatedMultiCOAs !== selectedList) {
        this.setState({ updatedMultiCOAs: selectedList });
      }
    }
  }

  autoSelectDateForCOA = () => {
    let searchData = [...this.state.searchData];
    if (this.state.selectedSearch.length > 0 && this.state.displayDate === "Date") {
      let today = new Date();
      let previousYrDate = new Date();
      previousYrDate.setFullYear(previousYrDate.getFullYear() - 1);
      let formattedToday = this.dateFormat(today);
      let formattedPreviousYrDate = this.dateFormat(previousYrDate);
      let displayDate = formattedPreviousYrDate + " - " + formattedToday;
      if (searchData.filter(e => e.name === "date").length > 0) {
        const index = searchData.findIndex((x) => x.name === "date");
        searchData[index].value = formattedPreviousYrDate;
        searchData[index].value2 = formattedToday;
      } else {
        searchData.push({ name: "date", value: formattedPreviousYrDate, value2: formattedToday });
      }
      this.setState({searchData, displayDate, });
    }
  }

  showDailyActivitySlideout = (row) => {
    // debugger;
    let ClMonth: any = 0;
    let ClYear: any = 0;
    if (row.cl !== "") {
      let newDate = new Date(row.cl.split("-")[0] + "/01/" + row.cl.split("-")[1]);
      ClMonth = Number((newDate).getMonth()) + 1;
      ClYear = (newDate).getFullYear();
    } else {
      let newDate = new Date(row.date);
      ClMonth = Number((newDate).getMonth()) + 1;
      ClYear = (newDate).getFullYear();
    }
    let request: any = {};
    request.uniqueno = row.uniqueno;
    request.hotelID = row.backhid;
    request.oprID = row.oprid;
    request.date = row.date;
    request.type = row.vendor;
    request.entryType = "a";
    request.ClMonth = ClMonth;
    request.ClYear = ClYear;

    let depReqDetails = row.backhid + "[" + row.oprid + "[" + row.date + "[" + request.type + "[" + ClMonth + "[" + ClYear;

    this.setState({ isDailyActivityOpen: true, dailyActivityRequest: request, depReqDetails });
  }

  hideDailyActivitySlideout = () => {
    this.setState({ isDailyActivityOpen: false, dailyActivityRequest: {}, depReqDetails: "" });
  }

  render() {


    let moreFilters = this.state.moreFilters.filter(e => e.filterName !== this.state.selectCategories.categoriesName)
    let serachData = this.state.tableActiveTab === "regular" ? this.state.searcResult.filter(e => e.viewType === 1) : this.state.searcResult.filter(e => e.viewType === 2);
    const sizePerPageOptionRenderer = ({
      text,
      page,
      onSizePerPageChange
    }) => (
      <li
        key={ text }
        role="presentation"
        className="dropdown-item"
      >
        <a
          href="javascript:void(0);"
          data-page={ page }
          onMouseDown={ (e) => {        
            if(page == serachData.length){
              this.setState(() => ({loader: true}));              
              setTimeout(() => {
                onSizePerPageChange(page);
                setTimeout(() => {
                  this.setState(() => ({loader: false}));
                }, 3000);
              }, 500);
            }else{
              onSizePerPageChange(page);
            }
          } }
        >
          { text }
        </a>
      </li>
    );
    const options = {
      custom: true,
      totalSize: serachData.length,
      paginationSize: 4,
      pageStartIndex: 1,
      sizePerPageList: serachData.length > 1500 ? [{
        text: '50', value: 50
      }, {
        text: '100', value: 100
      }, {
        text: '200', value: 200
      }] :
      [{
        text: '50', value: 50
      }, {
        text: '100', value: 100
      }, {
        text: '200', value: 200
      }, {
        text: 'View All', value: serachData.length
      }],
      sizePerPageOptionRenderer,
    };
    const contentTable = ({ paginationProps, paginationTableProps }) => (
      <div className={this.state.densityName}>
        <div className={`
            ${this.state.chipList.length > 0 ? "filter-enable" : ""}
            ${this.state.isSubVendorBanner && this.state.tableActiveTab === "regular" ? "subVendor-Banner" : ""}
        `}>
          <BootstrapTable keyField="rowNo" data={serachData} columns={this.state.columns} {...paginationTableProps} rowEvents={this.rowEvents} />
          <div className="pagination-sec d-flex align-items-center">
            <div className="total-list d-flex align-items-center">
              <SizePerPageDropdownStandalone 
                variation = {serachData.length > paginationProps.sizePerPage*paginationProps.page ||
                   (serachData.length -  paginationProps.sizePerPage*(paginationProps.page - 1)) > 5 && this.state.densityName == "compact" ||
                   (serachData.length -  paginationProps.sizePerPage*(paginationProps.page - 1)) > 4 && this.state.densityName == "narrow" ||
                   (serachData.length -  paginationProps.sizePerPage*(paginationProps.page - 1)) > 3 && this.state.densityName == "wide"  ? "dropup" : "dropdown"} 
                {...paginationProps} 
              />
              <div className="count-show">{serachData.length == 0 ? 0 : (paginationProps.page * (paginationProps.sizePerPage > serachData.length ? serachData.length : paginationProps.sizePerPage))-((paginationProps.sizePerPage > serachData.length ? serachData.length : paginationProps.sizePerPage)-1)} - {((paginationProps.sizePerPage*paginationProps.page) > serachData.length ? serachData.length : (paginationProps.sizePerPage*paginationProps.page))}  of {serachData.length} Entries</div>
            </div>
            <div className="pagination-list mr-auto"><PaginationListStandalone {...paginationProps} /></div>
            <div className="search-total mrgn-right-32">Search Total: {serachData.length > 0 ? Utils.currencyFormat(serachData[0].searchTotal) : "$0.00"}</div>
          </div>
        </div>
      </div>
    );


    return (
      <div className="search-result">
        {/* <ToastContainer
          autoClose={3000}
          containerId={"accountSearch"}
          enableMultiContainer
        /> */}
        {this.state.isDailyActivityOpen && (
          <DailyActivitySlideOut
            hidValue={this.state.sildeoutHid}
            hideDailyActivitySlideout={this.hideDailyActivitySlideout}
            dailyActivityRequest={this.state.dailyActivityRequest}
            depReqDetails={this.state.depReqDetails}
          />
        )}

        {this.state.isSlideOut && (
          <>
            {(this.state.pageType === "Invoice" || this.state.pageType === "Incompleteinvoice") ?
              <InvoiceEntrySlideout
                hidValue={this.state.sildeoutHid}
                hotelName={""}
                uniqueNo={this.state.trUniqueNo}
                pageType={this.state.pageType}
                oprId={this.state.oprId}
                vid={this.state.vid}
                hideSlideOut={this.hideSlideOut.bind(this)}
                OpenInvoiceSlideOut={this.OpenInvoiceSlideOut.bind(this)}
                selectedRow={this.state.selectedRow}
              />
              :
              <TransactionSlideout
                accDetails={this.state.registerRequest}
                hidValue={this.state.sildeoutHid}
                hotelName={""}
                uniqueNo={this.state.trUniqueNo}
                pageType={this.state.pageType}
                hideSlideOut={this.hideSlideOut.bind(this)}
                OpenInvoiceSlideOut={this.OpenInvoiceSlideOut.bind(this)}
                selectedRow={this.state.selectedRow}
              />
            }
          </>

        )}

        {this.state.isConfirmationModal &&
        confirmAlert({
          message: "Searching without a date range may cause a large dataset to return, and will take some time to populate. Are you sure you want to continue?",
          buttons: [{
              label: "Yes",
              onClick: () => { this.handleSearch("yes") },
          },
          {
              label: "No",
              onClick: () => this.rejectConfirmation(),
          },
          ],
          closeOnEscape: false,
          closeOnClickOutside: false,
      })

        }


        {this.state.isTransferSlideOut && (
          <TransferSlideout
            accDetails={this.state.registerRequest}
            hidValue={this.state.sildeoutHid}
            hotelName={""}
            uniqueNo={this.state.trUniqueNo}
            pageType={this.state.pageType}
            transferRequest={this.state.transferRequest}
            hideTrSlideOut={this.hideTrSlideOut.bind(this)}
          />
        )}

        {this.state.isTRSideOut && (
          <JournalSlideOut
            JERequest={this.state.JERequest}
            hidValue={this.state.sildeoutHid}
            hotelName={""}
            hideSlideOut={this.hideSlideOut.bind(this)}
            newRequest={true}
            hasAddPermission={this.state.hasAddPermission}
            isFromRepeating={false}
          />

        )}

        {this.state.isCCSlideout && (
          <CreditCardSlideout
            accDetails={this.state.registerRequest}
            hidValue={this.state.sildeoutHid}
            hotelName={this.state.hotelName}
            uniqueNo={this.state.trUniqueNo}
            oprId={this.state.oprId}
            vid={this.state.vid}
            pageType={this.state.ccSlideType}
            hideCCSlideOut={this.hideCCSlideOut.bind(this)}
          />
        )}
        <Container fluid className="body-sec">          
          <div className="page-heading underline d-flex">
            <div className="mr-auto d-flex align-items-center">Accounting Search</div>
            <div className="action-group d-flex">
              <Dropdown className="more-action three-dot" alignRight onSelect={this.handleTripleDotsMenu}>
                  <Dropdown.Toggle className="btn-outline-primary btn btn-primary more" id="dropdown-more">
                      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M11.875 10C11.875 11.0352 11.0352 11.875 10 11.875C8.96484 11.875 8.125 11.0352 8.125 10C8.125 8.96484 8.96484 8.125 10 8.125C11.0352 8.125 11.875 8.96484 11.875 10Z" />
                          <path d="M5.625 10C5.625 11.0352 4.78516 11.875 3.75 11.875C2.71484 11.875 1.875 11.0352 1.875 10C1.875 8.96484 2.71484 8.125 3.75 8.125C4.78516 8.125 5.625 8.96484 5.625 10Z" />
                          <path d="M18.125 10C18.125 11.0352 17.2852 11.875 16.25 11.875C15.2148 11.875 14.375 11.0352 14.375 10C14.375 8.96484 15.2148 8.125 16.25 8.125C17.2852 8.125 18.125 8.96484 18.125 10Z" />
                      </svg>
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    <Dropdown.Item eventKey={"transactionExportByEhid"}>Transaction Export by EHID</Dropdown.Item>
                  </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
          <div className={this.state.loader ? "bdy-sec loader-active pos-relative" : "bdy-sec pos-relative"}>
            {(this.state.isSearchEHIDFlagBanner || this.state.isSubVendorBanner) && this.state.tableActiveTab === "regular" &&
              <div className="notification-banners orange-bg align-items-center">
                <div>To view the payment and deposit amounts that match your search criteria, select the <span className="bold inline-link" onClick={() => this.regularOrSplitClick("split")}>Split View</span></div>
              </div>           
            }
            <div className="fltr-sec d-flex flex-wrap align-items-center">
              <div className="left-sec mr-auto">
                <div className="d-flex">
                    <div className="categories-search">
                      <InputGroup className={this.state.selectedSearch.length === 0 ? "d-flex align-items-center red" : "d-flex align-items-center"}>
                        <InputGroup.Prepend id="btnGroupAddon">
                          <Dropdown className="EmpInput">
                            <Dropdown.Toggle id="dropdown-categories">
                              <div className="d-flex align-items-center height-100">
                                <div className="value mr-auto"><EllipsisWithTooltip placement="bottom">{this.state.selectCategories.categoriesName}</EllipsisWithTooltip></div>
                                <div className="arrow">
                                  <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                  </svg>
                                </div>
                              </div>
                            </Dropdown.Toggle>
                            <Dropdown.Menu>
                              {this.state.allcategories.map(
                                (item: any, index: any) => (
                                  <Dropdown.Item
                                    key={item.eventName}
                                    eventKey={item.categoriesName}
                                    className={this.state.selectCategories.categoriesName === item.categoriesName ? "active" : ""}
                                    onClick={() => { this.categoriesSelect(item) }}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div className="selected-value mr-auto">{item.categoriesName}</div>
                                      <div className="tick-mark">
                                        <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M4.49998 6.68951L2.03023 4.21976L0.969727 5.28026L4.49998 8.81051L11.7802 1.53026L10.7197 0.469757L4.49998 6.68951Z" fill="#2CAF92" />
                                        </svg>
                                      </div>
                                    </div>

                                  </Dropdown.Item>
                                )
                              )}
                            </Dropdown.Menu>
                          </Dropdown>
                        </InputGroup.Prepend>
                        {(this.state.selectCategories.categoriesName === "Vendor" || this.state.selectCategories.categoriesName === "COA") ? (
                        <>
                          {this.state.selectCategories.categoriesName === "Vendor" &&
                            <Typeahead
                              key="id"
                              id="searchAC"
                              onInputChange={input => this.onTypeAheadInputChange(input)}
                              onChange={(event) => {
                                this.typeheadChange(event);
                              }}
                              options={this.state.searchList}
                              placeholder={"Search"}
                              selected={this.state.selectedSearch}
                              onBlur={(e) => this.handleTypeAheadBlur(e)}
                              renderMenu={(results: any, menuProps) => (
                                <Menu {...menuProps}>
                                  {results.map((result: any, index: any) => (
                                    <>
                                      {result.label !== "" && (
                                        <MenuItem option={result} position={index}>
                                          <EllipsisWithTooltip placement="bottom">{result.label}</EllipsisWithTooltip>
                                        </MenuItem>
                                      )}
                                      {result.label === "" && (
                                        <MenuItem className="load-more" option={result} position={index}>
                                          Load More
                                        </MenuItem>
                                      )}
                                    </>
                                  ))}
                                </Menu>
                              )}
                            />
                          }
                          {this.state.selectCategories.categoriesName === "COA" &&
                            <MultiSelectCoaWithSearch
                              coaList={this.state.coaList}
                              selectedMultiCOAs={this.state.selectedMultiCOAs}
                              onSelectCOAs={this.onSelectCOAs.bind(this)}
                              filterType="main"
                              autoSelectDateForCOA={this.autoSelectDateForCOA.bind(this)}
                            />
                          }
                        </>
                        ) : (
                          <FormControl type="text" placeholder="Search" value={this.state.selectedSearch} onBlur={(e) => this.amountValidation(e, this.state.selectCategories.categoriesName)} onChange={(e: any) => { this.txtSearch(e) }} />
                        )}

                      </InputGroup>
                    </div>
                  <div className="d-flex align-items-center exact-match">
                    <Form.Check 
                    style={{opacity: this.state.selectCategories.categoriesName === "Vendor" || this.state.selectCategories.categoriesName === "COA" ? 0 : 1}}
                    custom type="checkbox" 
                    id={"exact-match"} 
                    checked={this.state.isExactMatchChecked}
                    disabled={this.state.selectCategories.categoriesName === "Vendor" || this.state.selectCategories.categoriesName === "COA" ? true : false}
                    onChange={(e) => this.exactMatchCheckToggle(e)}
                    label={"Exact Match"}
                    />
                  </div>
                  <div className="ehid-search">
                    <Dropdown className="more-action dropdown single-select-image">
                      <Dropdown.Toggle id="rolesList" className="without-border drop-lable">{/*className="filter-btn"*/}
                        {this.state.allehidData.filter(i => i.isChecked === true).length === 0 && (
                          <div className="d-flex align-items-center">
                            <div className="d-flex margin-right-10">
                              <div>EHID</div>
                            </div>
                            <div className="inpute-icon">
                              <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.054467 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z" fill="#3F4347" />
                              </svg>
                            </div>
                          </div>
                        )}
                        {this.state.allehidData.filter(i => i.isChecked === true).length === 1 && (
                          <div className="d-flex align-items-center">
                            <div className="d-flex margin-right-10">
                              <div>{this.state.allehidData.filter(i => i.isChecked === true)[0].hid}</div>
                            </div>
                            <div className="inpute-icon">
                              <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.054467 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z" fill="#3F4347" />
                              </svg>
                            </div>
                          </div>
                        )}
                        {this.state.allehidData.filter(i => i.isChecked === true).length > 1 && (
                          <div className="d-flex align-items-center">
                            <div className="d-flex margin-right-10">
                              <div>EHID</div>
                              <div className="cusBadge badgePrimary">{this.state.allehidData.filter(i => i.isChecked === true).length}</div>
                            </div>
                            <div className="inpute-icon">
                              <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.054467 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z" fill="#3F4347" />
                              </svg>
                            </div>
                          </div>
                        )}

                      </Dropdown.Toggle>
                      <Dropdown.Menu className="rolePermissionSelector">
                        <div className="search-sec">
                          <input
                            type="text"
                            className="form-control"
                            onChange={(e: any) => this.handleChange(e)}
                            placeholder={this.state.searchText}
                            value={this.state.inputValue}
                          />
                        </div>
                        <div className="dropdownItems">
                          {this.state.allehid.length > 0 &&
                            this.state.allehid.map((items, index) => (
                              <div className="dropdown-item" key={index}>
                                <Form.Check
                                    id={`list_${items.ehidVal}`}
                                    className="d-flex align-items-center"
                                  >
                                    <Form.Check.Input checked={items.isChecked} name={items.ehidName.toLowerCase()} value={items.ehidVal}
                                      onChange={(event) =>
                                        this.onChangeHIDFilter(event, items)
                                      } 
                                      type={"checkbox"}
                                    />
                                    <EllipsisWithTooltip placement="bottom">
                                      <Form.Check.Label>{items.ehidName}</Form.Check.Label>
                                    </EllipsisWithTooltip>
                                  </Form.Check>
                              </div>
                            ))}
                        </div>
                        <div className="footer">
                          {this.state.isSelect && this.state.allehid.length > 0 && (
                            <button id="selectAll" type="button"
                              className="btn wht-bg txt-green"
                              onClick={this.handleSelectAll}>Select All</button>
                          )}
                          {!this.state.isSelect && (
                            <button id="ClearAll" type="button"
                              className="btn wht-bg txt-green"
                              onClick={this.handleClearAll}>Clear All</button>
                          )}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>

                  </div>
                  <div className={this.state.displayDate.toLowerCase() !== "date" ? "calendar-search d-flex align-items-center selected-date" : "calendar-search d-flex align-items-center"}>
                    <div className="calendar-inpute d-flex align-items-center">
                      <div className="cal-icon"  onClick={this.handleCalendarOpen}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M4.66675 7.3335H6.00008V8.66683H4.66675V7.3335ZM4.66675 10.0002H6.00008V11.3335H4.66675V10.0002ZM7.33341 7.3335H8.66675V8.66683H7.33341V7.3335ZM7.33341 10.0002H8.66675V11.3335H7.33341V10.0002ZM10.0001 7.3335H11.3334V8.66683H10.0001V7.3335ZM10.0001 10.0002H11.3334V11.3335H10.0001V10.0002Z" fill="#3F4347" />
                          <path d="M3.33333 14.6668H12.6667C13.402 14.6668 14 14.0688 14 13.3335V5.3335V4.00016C14 3.26483 13.402 2.66683 12.6667 2.66683H11.3333V1.3335H10V2.66683H6V1.3335H4.66667V2.66683H3.33333C2.598 2.66683 2 3.26483 2 4.00016V5.3335V13.3335C2 14.0688 2.598 14.6668 3.33333 14.6668ZM12.6667 5.3335L12.6673 13.3335H3.33333V5.3335H12.6667Z" fill="#3F4347" />
                        </svg>
                      </div>
                      <div className="date-range" onClick={this.handleCalendarOpen}>{this.state.displayDate}</div>
                      {this.state.displayDate.toLowerCase() !== "date" &&(
                        <div className="cross" onClick={()=>{this.clearDateFilter()}}>
                          <svg width="8" height="8" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M8.49331 0.286621L4.95747 3.82162L1.42247 0.286621L0.244141 1.46495L3.77914 4.99995L0.244141 8.53496L1.42247 9.71329L4.95747 6.17829L8.49331 9.71329L9.67164 8.53496L6.13664 4.99995L9.67164 1.46495L8.49331 0.286621Z" />
                          </svg>
                        </div>
                      )}
                      <div className="inpute-icon" onClick={this.handleCalendarOpen}>
                        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M3.28122e-05 1.19724C3.28122e-05 0.889538 0.253262 0.653982 0.543288 0.653982C0.688297 0.653982 0.833313 0.708449 0.923855 0.816677L4.0023 4.0217L7.08074 0.816677C7.2979 0.599519 7.6424 0.599519 7.84116 0.816677C8.04064 1.01616 8.05831 1.34153 7.85955 1.55941L4.40046 5.18112C4.20098 5.39827 3.85721 5.39828 3.64005 5.19951L3.62166 5.18112L0.145009 1.55941C0.054467 1.46887 0 1.34226 0 1.19724L3.28122e-05 1.19724Z" fill="#3F4347" />
                        </svg>
                      </div>
                    </div>
                    <OutsideClickHandler onOutsideClick={() => this.handleOutSideDateClick("calendar")}>
                      {this.state.isCalendarOpen && (
                        <div className="calendar-picker">
                          <div className="header d-flex align-items-center">
                            <div className="ttl mr-auto">Date Range</div>
                            <div className="cross" onClick={this.handleCalendarOpen}>
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.49331 0.286621L4.95747 3.82162L1.42247 0.286621L0.244141 1.46495L3.77914 4.99995L0.244141 8.53496L1.42247 9.71329L4.95747 6.17829L8.49331 9.71329L9.67164 8.53496L6.13664 4.99995L9.67164 1.46495L8.49331 0.286621Z" fill="#84888C" />
                              </svg>
                            </div>
                          </div>
                          <div className="body">
                            <div className="section">
                              <ButtonGroup aria-label="Transaction-Accounting">
                                <Button className={this.state.calendarActiveTab === "transaction" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleSelect("transaction") }}>Transaction Date</Button>
                                <Button className={this.state.calendarActiveTab === "accounting" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleSelect("accounting") }}>Accounting Period</Button>
                              </ButtonGroup>
                            </div>
                            {this.state.calendarActiveTab === "transaction" &&(
                              <div className="range-sec">
                                <DateRange
                                  editableDateInputs={true}
                                  onChange={(item) => { this.dateRangeSelect([item.selection]) }}
                                  moveRangeOnFirstSelection={false}
                                  ranges={this.state.dateRange}
                                />
                                <div className="value">
                                  <InputGroup className="mb-3">
                                    <Form.Control aria-label="From" placeholder="From" value={this.state.startDate} onChange={(e) => this.dateChange(e, "start")} onBlur={(e) => this.dateBlur(e, "start")} />
                                    <Form.Control aria-label="To" placeholder="To" value={this.state.endDate} onChange={(e) => this.dateChange(e, "end")} onBlur={(e) => this.dateBlur(e, "end")} />
                                  </InputGroup>
                                </div>
                              </div>
                            )}
                            {this.state.calendarActiveTab === "accounting" && (
                              <div className="range-sec">
                                <Calendar 
                                  ref={this.datePickerRef}
                                  onlyMonthPicker
                                  range
                                  value={this.state.monthRange}
                                  onChange={(dateObjects) => { this.monthRangeSelect(dateObjects)}} 
                                  hideMonth={true}                                 
                                />                               
                                <div className="value">
                                  <InputGroup className="mb-3">
                                    <Form.Control aria-label="From" placeholder="From" value={this.state.startMonthRange} onChange={(e) => this.dateChange(e, "start")}onBlur={(e) => this.dateBlur(e, "start")} />
                                    <Form.Control aria-label="To" placeholder="To" value={this.state.endMonthRange} onChange={(e) => this.dateChange(e, "end")} onBlur={(e) => this.dateBlur(e, "end")} />
                                  </InputGroup>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="footer">
                            <div className="action d-flex justify-content-end">
                              <Button className="without-border margin-right-15" variant="primary" onClick={this.handleCalendarOpen}>Cancel</Button>
                              <Button variant="primary" onClick={() => { this.dateSave() }}>Save</Button>
                            </div>
                          </div>
                        </div>
                      )}
                    </OutsideClickHandler>
                  </div>
                  <div className="more-search d-flex align-items-center margin-right-15">
                    <Dropdown onSelect={this.handleMoreFilter}>
                      <Dropdown.Toggle className="without-border" id="dropdown-more-search">{"More Filters"} </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {moreFilters.map(
                          (item: any, index: any) => (
                            <Dropdown.Item
                              key={item.eventName}
                              eventKey={item.filterName}>
                              <EllipsisWithTooltip placement="bottom">{item.filterName}</EllipsisWithTooltip>
                            </Dropdown.Item>
                          )
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                    <OutsideClickHandler onOutsideClick={() => this.handleOutSideDateClick("customModal")}>
                      {this.state.isCustomModalOpen && (
                        <div className="custom-modal">
                          <div className="header d-flex align-items-center">
                            <div className="ttl mr-auto">{this.state.isCustomModalType}</div>
                            <div className="cross" onClick={() => { this.handleCustomModal("more") }}>
                              <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M8.49331 0.286621L4.95747 3.82162L1.42247 0.286621L0.244141 1.46495L3.77914 4.99995L0.244141 8.53496L1.42247 9.71329L4.95747 6.17829L8.49331 9.71329L9.67164 8.53496L6.13664 4.99995L9.67164 1.46495L8.49331 0.286621Z" fill="#84888C" />
                              </svg>
                            </div>
                          </div>
                          <div className="body">
                            <div className="section">
                              {this.state.isCustomModalType === "Transaction Type" && (
                                <Dropdown onSelect={this.handletransationType}>
                                  <Dropdown.Toggle className={this.state.selectedTransationType === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                    <div className="d-flex align-items-center height-100">
                                      <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedTransationType}</EllipsisWithTooltip></div>
                                      <div className="arrow">
                                        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                        </svg>
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {this.state.transactionList.map(
                                      (item: any, index: any) => (
                                        <Dropdown.Item
                                          key={item.eventName}
                                          eventKey={item.transationName}>
                                          <EllipsisWithTooltip placement="bottom">{item.transationName}</EllipsisWithTooltip>
                                        </Dropdown.Item>
                                      )
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}

                              {this.state.isCustomModalType === "Ledger Type" && (
                                <Dropdown onSelect={this.handleLedgerType}>
                                  <Dropdown.Toggle className={this.state.selectedLedgerType === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                    <div className="d-flex align-items-center height-100">
                                      <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedLedgerType}</EllipsisWithTooltip></div>
                                      <div className="arrow">
                                        <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                        </svg>
                                      </div>
                                    </div>
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    {this.state.ledgerTypeList.map(
                                      (item: any, index: any) => (
                                        <Dropdown.Item
                                          key={item.eventName}
                                          eventKey={item.ledgerType}>
                                          <EllipsisWithTooltip placement="bottom">{item.ledgerType}</EllipsisWithTooltip>
                                        </Dropdown.Item>
                                      )
                                    )}
                                  </Dropdown.Menu>
                                </Dropdown>
                              )}

                              {(this.state.isCustomModalType === "Customer No."
                                || this.state.isCustomModalType === "Vendor") && (
                                  <>
                                    <Typeahead
                                      key="idmore"
                                      id="searchmoreAC"
                                      onInputChange={input => this.onTypeAheadMoreChange(input)}
                                      onChange={(event) => {
                                        this.typeheadMoreChange(event);
                                      }}
                                      options={this.state.searchMoreList}
                                      placeholder={"Search"}
                                      selected={this.state.selectedMoreSearch}
                                      renderMenu={(results: any, menuProps) => (
                                        <Menu {...menuProps}>
                                          {results.map((result: any, index: any) => (
                                            <>
                                              {result.label !== "" && (
                                                <MenuItem option={result} position={index}>
                                                  <EllipsisWithTooltip placement="bottom">{result.label}</EllipsisWithTooltip>
                                                </MenuItem>
                                              )}
                                              {result.label === "" && (
                                                <MenuItem className="load-more" option={result} position={index}>
                                                  Load More
                                                </MenuItem>
                                              )}
                                            </>
                                          ))}
                                        </Menu>
                                      )}
                                    />
                                  </>
                                )}
                              {(this.state.isCustomModalType === "COA") && (
                                <>
                                  <MultiSelectCoaWithSearch
                                    coaList={this.state.coaList}
                                    selectedMultiCOAs={this.state.selectedMultiCOAs}
                                    onSelectCOAs={this.onSelectCOAs.bind(this)}
                                    filterType="more"
                                    autoSelectDateForCOA={this.autoSelectDateForCOA.bind(this)}
                                  />
                                </>
                              )}
                              {(this.state.isCustomModalType === "Exclude Unpaid Invoices & Unapproved Transactions") && (
                                  <Dropdown>
                                    <Dropdown.Toggle className={this.state.selectedYesNo === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                      <div className="d-flex align-items-center height-100">
                                        <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedYesNo}</EllipsisWithTooltip></div>
                                        <div className="arrow">
                                          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                          </svg>
                                        </div>
                                      </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      <Dropdown.Item key={"yes"} eventKey={"Yes"} onClick={() => { this.handleDDL("Yes") }}>Yes</Dropdown.Item>
                                      <Dropdown.Item key={"no"} eventKey={"No"} onClick={() => { this.handleDDL("No") }}>No</Dropdown.Item>
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}

                              {(this.state.isCustomModalType === "Check No."
                                || this.state.isCustomModalType === "Amount"
                                || this.state.isCustomModalType === "Notes & Descriptions"
                                || this.state.isCustomModalType === "Invoice No."
                                || this.state.isCustomModalType === "Cleared Acct. Per.") && (
                                  <FormControl type="text" placeholder={this.state.isCustomModalType === "Cleared Acct. Per." ? "MM-YY" : this.state.isCustomModalType} value={this.state.txtMoreSearch} onChange={(e) => { this.txtMoreChange(e,this.state.isCustomModalType) }} />
                                )}
                              {(this.state.isCustomModalType === "Amount" || this.state.isCustomModalType === "Check No."
                                  || this.state.isCustomModalType === "Invoice No." || this.state.isCustomModalType === "Notes & Descriptions"
                                  || this.state.isCustomModalType === "Customer No.") && (
                                <div className="exact-match-group">
                                  <ButtonGroup aria-label="Exact-match">
                                    <Button className={this.state.toggleMatchActiveTab === "contains" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleMatchSelector("contains") }}>Contains</Button>
                                    <Button className={this.state.toggleMatchActiveTab === "exact" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleMatchSelector("exact") }}>Exact Match</Button>
                                  </ButtonGroup>
                                </div>
                              )}

                            </div>
                          </div>
                          <div className="footer">
                            <div className="action d-flex justify-content-end">
                              <Button className="without-border margin-right-15" variant="primary" onClick={() => this.handleCustomModal("more")}>Cancel</Button>
                              <Button variant="primary" onClick={(e) => { this.handleAddChip(this.state.isCustomModalType) }}>Add</Button>
                            </div>
                          </div>
                        </div>
                      )}
                    </OutsideClickHandler>
                  </div>
                    <Button className="margin-right-15" variant="primary" disabled={this.state.selectedSearch.length === 0 ? true : false} ref={this.searchBtnRef} onClick={() => {setTimeout(() => this.handleSearch("search"), 500) }}>Search</Button>
                    <Button variant="primary" style={{display: this.state.searchData.length === 0 || this.state.loader ? "none " : ""}} className="btn-outline-primary margin-right-15" onClick={() => { this.resetFilters() }}>Reset</Button>
                </div>
              </div>
              <div className="right-sec d-flex">
                <div className="section">
                  <ButtonGroup aria-label="Regular-Split" className="margin-right-15">
                    <Button className={this.state.tableActiveTab === "regular" ? "active" : ""} variant="secondary" onClick={(e) => { this.regularOrSplitClick("regular") }}>Regular</Button>
                    <Button className={this.state.tableActiveTab === "split" ? "active" : ""} variant="secondary" onClick={(e) => { this.regularOrSplitClick("split") }}>Split</Button>
                  </ButtonGroup>
                </div>
                <div className="section">
                  <Button id="btnexport" className="without-border margin-right-15" variant="primary" onClick={this.getExport}>Export</Button>
                  <Button className="without-border margin-right-15" variant="primary" style={{ display: "none" }}>
                    <CSVLink id="btnexport1" data={exportDataSet}
                      filename={this.state.excelfileName + ".csv"}>Export</CSVLink></Button></div>
                <div className="gear-icon">
                  <Dropdown className="dropdown-gear-icon">
                    <Dropdown.Toggle id="dropdown-gear-icon" className="d-flex align-items-center">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M1.56286 10.1808L2.89619 12.4875C3.08019 12.8062 3.48819 12.9155 3.80686 12.7308L4.73752 12.1935C5.12419 12.4982 5.55152 12.7482 6.00086 12.9348V14.0002C6.00086 14.3682 6.29886 14.6668 6.66752 14.6668H9.33419C9.70286 14.6668 10.0009 14.3682 10.0009 14.0002V12.9348C10.4502 12.7482 10.8769 12.4982 11.2642 12.1935L12.1949 12.7308C12.5129 12.9142 12.9222 12.8042 13.1055 12.4875L14.4389 10.1808C14.6222 9.8635 14.5122 9.4535 14.1955 9.27016L13.2809 8.7415C13.3155 8.4955 13.3335 8.2475 13.3335 8.00016C13.3335 7.75283 13.3155 7.50483 13.2795 7.25883L14.1942 6.73016C14.5115 6.54683 14.6215 6.13683 14.4375 5.8195L13.1042 3.51283C12.9202 3.19416 12.5122 3.08483 12.1935 3.2695L11.2629 3.80683C10.8762 3.50216 10.4495 3.2515 10.0002 3.0655V2.00016C10.0002 1.63216 9.70219 1.3335 9.33352 1.3335H6.66686C6.29819 1.3335 6.00019 1.63216 6.00019 2.00016V3.0655C5.55086 3.25216 5.12419 3.50216 4.73686 3.80683L3.80686 3.2695C3.48752 3.08483 3.08019 3.19416 2.89619 3.51283L1.56286 5.8195C1.37953 6.13683 1.48953 6.54683 1.80619 6.73016L2.72086 7.25883C2.68486 7.50483 2.66686 7.75283 2.66686 8.00016C2.66686 8.2475 2.68486 8.4955 2.72086 8.7415L1.80619 9.27016C1.48886 9.4535 1.37886 9.8635 1.56286 10.1808ZM8.00019 5.3335C9.47086 5.3335 10.6669 6.5295 10.6669 8.00016C10.6669 9.47083 9.47086 10.6668 8.00019 10.6668C6.52952 10.6668 5.33352 9.47083 5.33352 8.00016C5.33352 6.5295 6.52952 5.3335 8.00019 5.3335Z" />
                      </svg>
                      <div className="drop-arrow d-flex">
                        <FiChevronDown />
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Header>Density View Control</Dropdown.Header>
                      {this.state.allDensity.map(
                        (item: any, index: any) => (
                          <Dropdown.Item
                            key={item.eventName}
                            eventKey={item.densityName}
                            className={this.state.densityName === item.eventName ? "active" : ""}
                            onClick={() => { this.densitySelect(item) }}
                          >
                            <div className="d-flex align-items-center">
                              <div className="selected-value mr-auto">{item.densityName}</div>
                              <div className="tick-mark">
                                <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M4.49998 6.68951L2.03023 4.21976L0.969727 5.28026L4.49998 8.81051L11.7802 1.53026L10.7197 0.469757L4.49998 6.68951Z" fill="#2CAF92" />
                                </svg>
                              </div>
                            </div>
                          </Dropdown.Item>
                        )
                      )}
                      <Dropdown.Divider />
                      <Dropdown.Item eventKey="save-default" onClick={this.saveDefaultColumn}>Save as Default View</Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>
            <div className="chip-sec d-flex flex-wrap">
              {this.state.chipList.map(
                (item: any, index: any) => (
                  <div className="chip d-flex align-items-center">
                    <div className="category">{item.name}</div>
                    {item.name !== "Include Daily Activity Entries" &&
                      <div className="value d-flex align-items-center" onClick={() => { this.onchipClick(item, index) }}>
                        <div className="list">{item.value}</div>
                      </div>
                    }
                    <div className="cross" onClick={(e) => { this.handleRemoveChip(index) }}>
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.75011 0L4.99956 3.7496L1.24989 0L0 1.24987L3.74967 4.99947L0 8.74907L1.24989 9.99894L4.99956 6.24934L8.75011 9.99894L10 8.74907L6.25033 4.99947L10 1.24987L8.75011 0Z" fill="#84888C" />
                      </svg>
                    </div>
                    <>
                      <OutsideClickHandler onOutsideClick={() => this.handleOutSideChipClick(index)}>
                        {(this.state.chipClick !== "" && this.state.index === index) && (
                          <div className="custom-modal">
                            <div className="header d-flex align-items-center">
                              <div className="ttl mr-auto">{this.state.chipClick}</div>
                              <div className="cross" onClick={() => this.handleCustomModal("chip")}>
                                <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M8.49331 0.286621L4.95747 3.82162L1.42247 0.286621L0.244141 1.46495L3.77914 4.99995L0.244141 8.53496L1.42247 9.71329L4.95747 6.17829L8.49331 9.71329L9.67164 8.53496L6.13664 4.99995L9.67164 1.46495L8.49331 0.286621Z" fill="#84888C" />
                                </svg>
                              </div>
                            </div>
                            <div className="body">
                              <div className="section">
                                {this.state.chipClick === "Transaction Type" && (
                                  <Dropdown onSelect={this.handletransationType}>
                                    <Dropdown.Toggle className={this.state.selectedTransationType === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                      <div className="d-flex align-items-center height-100">
                                        <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedTransationType}</EllipsisWithTooltip></div>
                                        <div className="arrow">
                                          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                          </svg>
                                        </div>
                                      </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {this.state.transactionList.map(
                                        (item: any, index: any) => (
                                          <Dropdown.Item
                                            key={item.eventName}
                                            eventKey={item.transationName}>
                                            <EllipsisWithTooltip placement="bottom">{item.transationName}</EllipsisWithTooltip>
                                          </Dropdown.Item>
                                        )
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                                {this.state.chipClick === "Ledger Type" && (
                                  <Dropdown onSelect={this.handleLedgerType}>
                                    <Dropdown.Toggle className={this.state.selectedLedgerType === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                      <div className="d-flex align-items-center height-100">
                                        <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedLedgerType}</EllipsisWithTooltip></div>
                                        <div className="arrow">
                                          <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                          </svg>
                                        </div>
                                      </div>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                      {this.state.ledgerTypeList.map(
                                        (item: any, index: any) => (
                                          <Dropdown.Item
                                            key={item.eventName}
                                            eventKey={item.ledgerType}>
                                            <EllipsisWithTooltip placement="bottom">{item.ledgerType}</EllipsisWithTooltip>
                                          </Dropdown.Item>
                                        )
                                      )}
                                    </Dropdown.Menu>
                                  </Dropdown>
                                )}
                                {(this.state.chipClick === "Customer No."
                                  || this.state.chipClick === "Vendor") && (
                                    <Typeahead
                                      key="idmore"
                                      id="searchmoreAC"
                                      onInputChange={input => this.onTypeAheadMoreChange(input)}
                                      onChange={(event) => {
                                        this.typeheadMoreChange(event);
                                      }}
                                      options={this.state.searchMoreList}
                                      placeholder={"Search"}
                                      selected={this.state.selectedMoreSearch}
                                      renderMenu={(results: any, menuProps) => (
                                        <Menu {...menuProps}>
                                          {results.map((result: any, index: any) => (
                                            <>
                                              {result.label !== "" && (
                                                <MenuItem option={result} position={index}>
                                                  <EllipsisWithTooltip placement="bottom">{result.label}</EllipsisWithTooltip>
                                                </MenuItem>
                                              )}
                                              {result.label === "" && (
                                                <MenuItem className="load-more" option={result} position={index}>
                                                  Load More
                                                </MenuItem>
                                              )}
                                            </>
                                          ))}
                                        </Menu>
                                      )}
                                    />
                                  )}
                                {(this.state.chipClick === "COA") && (
                                  <>
                                    <MultiSelectCoaWithSearch
                                      coaList={this.state.coaList}
                                      selectedMultiCOAs={this.state.selectedMultiCOAs}
                                      onSelectCOAs={this.onSelectCOAs.bind(this)}
                                      filterType="more"
                                      autoSelectDateForCOA={this.autoSelectDateForCOA.bind(this)}
                                    />
                                  </>
                                )}
                                {(this.state.chipClick === "Exclude Unpaid Invoices & Unapproved Transactions") && (
                                    <Dropdown>
                                      <Dropdown.Toggle className={this.state.selectedYesNo === "Select" ? "select-box placeholder" : "select-box"} id="dropdown-more-search">
                                        <div className="d-flex align-items-center height-100">
                                          <div className="value mr-auto"><EllipsisWithTooltip placement="bottom"> {this.state.selectedYesNo}</EllipsisWithTooltip></div>
                                          <div className="arrow">
                                            <svg width="10" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M8.29268 0.29248L5.00001 3.58581L1.70735 0.29248L0.292679 1.70715L5.00001 6.41382L9.70735 1.70715L8.29268 0.29248Z" fill="#84888C" />
                                            </svg>
                                          </div>
                                        </div>
                                      </Dropdown.Toggle>
                                      <Dropdown.Menu>
                                        <Dropdown.Item key={"yes"} eventKey={"Yes"} onClick={() => { this.handleDDL("Yes") }}>Yes</Dropdown.Item>
                                        <Dropdown.Item key={"no"} eventKey={"No"} onClick={() => { this.handleDDL("No") }}>No</Dropdown.Item>
                                      </Dropdown.Menu>
                                    </Dropdown>
                                  )}

                                {(this.state.chipClick === "Check No."
                                  || this.state.chipClick === "Amount"
                                  || this.state.chipClick === "Notes & Descriptions"
                                  || this.state.chipClick === "Invoice No."
                                  || this.state.chipClick === "Cleared Acct. Per.") && (
                                    <FormControl type="text" placeholder={this.state.chipClick === "Cleared Acct. Per." ? "MM-YY" : this.state.chipClick} value={this.state.txtMoreSearch} onChange={(e) => { this.txtMoreChange(e,this.state.chipClick) }} />
                                  )}
                                  {(this.state.chipClick === "Amount" || this.state.chipClick === "Check No."
                                    || this.state.chipClick === "Invoice No." || this.state.chipClick === "Notes & Descriptions"
                                    || this.state.chipClick === "Customer No.") && (
                                    <div className="exact-match-group">
                                      <ButtonGroup aria-label="Exact-match">
                                        <Button className={this.state.toggleMatchActiveTab === "contains" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleMatchSelector("contains") }}>Contains</Button>
                                        <Button className={this.state.toggleMatchActiveTab === "exact" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleMatchSelector("exact") }}>Exact Match</Button>
                                      </ButtonGroup>
                                    </div>
                                  )}

                              </div>
                            </div>
                            <div className="footer">
                              <div className="action d-flex justify-content-end">
                                <Button className="without-border margin-right-15" variant="primary" onClick={() => this.handleCustomModal("chip")}>Cancel</Button>
                                <Button variant="primary" onClick={(e) => { this.handleAddChip(this.state.chipClick) }}>Add</Button>
                              </div>
                            </div>
                          </div>
                        )}
                      </OutsideClickHandler>
                    </>
                  </div>
                )
              )}

            </div>
            {serachData.length > 0 && (
              <>
                {(serachData[0].totalRowCount1 !== serachData[0].totalRowCount) && (
                  <div className="warning-msg d-flex">
                    <div className="mr-auto"><span className="bold">WARNING:</span> These search results may be incomplete. The results below only include transactions linked to those items you have permission to view</div>
                  </div>
                )}
              </>
            )}
            <div className="result-area">
              {this.state.searchStart && (
                <div>
                  <div className={this.state.densityName !== "wide" ? "handle-column height-40" : "handle-column"}>
                    <Dropdown className="split-icon-header" alignRight>
                      <Dropdown.Toggle className="d-flex align-items-center" id="dropdown-split-icon">
                        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M16.3914 2H3.60861C2.72146 2 2 2.79733 2 3.77778V16.2222C2 17.2027 2.72146 18 3.60861 18H16.3914C17.2785 18 18 17.2027 18 16.2222V6.44356V5.55467V4.66578V3.77778V3.77689C17.9992 2.79644 17.2769 2 16.3914 2ZM6.82582 16.2222H3.60861V6.44356H6.82582V16.2222ZM11.6516 16.2222H8.43442V6.44356H11.6516V16.2222ZM13.2602 16.2222V6.44356H16.3914L16.3922 16.2222H13.2602Z" />
                        </svg>
                        <div className="drop-arrow d-flex">
                          <FiChevronDown />
                        </div>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Header>Columns</Dropdown.Header>
                        <div className="scroll-area">

                          {this.state.tableColumnList.map((items, index) => (
                            <div className="dropdown-item" key={"custom-s" + index}>
                              <EllipsisWithTooltip placement="bottom">
                                <Form.Check
                                  custom
                                  type="checkbox"
                                  id={`list_${items.id}`}
                                  name={items.name.toLowerCase()}
                                  label={items.name}
                                  value={items.id}
                                  onChange={(event) =>
                                    this.onHandleColumn(event, items, index)
                                  }
                                  checked={items.isChecked}
                                  disabled={items.disabled}
                                />
                              </EllipsisWithTooltip>
                            </div>
                          ))}
                        </div>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                  <div>
                    {this.state.isColumnChange && (
                      <PaginationProvider pagination={paginationFactory(options)}>
                        {contentTable}
                      </PaginationProvider>
                    )}
                  </div>
                </div>
              )}              
              {!this.state.searchStart && (
                <div className="empty-state">
                  <svg width="239" height="142" viewBox="0 0 239 142" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_755_26819)">
                      <path d="M130.629 52.4185L123.426 59.6213L144.134 80.3292L151.336 73.1264L130.629 52.4185Z" fill="#CACED2" />
                      <path d="M168.464 97.4636C171.845 94.0818 171.845 88.5988 168.464 85.2169L145.291 62.0441C144.031 60.7841 141.988 60.7841 140.728 62.0441L133.044 69.7283C131.784 70.9882 131.784 73.0308 133.044 74.2908L156.217 97.4636C159.599 100.845 165.082 100.845 168.464 97.4636Z" fill="#84888C" />
                      <path d="M105.812 69.6246C86.586 69.6246 71 54.0386 71 34.8123C71 15.586 86.586 0 105.812 0C125.039 0 140.625 15.586 140.625 34.8123C140.625 54.0386 125.039 69.6246 105.812 69.6246Z" fill="#E0E3E6" />
                      <path d="M105.812 59.7431C92.0434 59.7431 80.8814 48.5811 80.8814 34.8122C80.8814 21.0433 92.0434 9.88135 105.812 9.88135C119.581 9.88135 130.743 21.0433 130.743 34.8122C130.743 48.5811 119.581 59.7431 105.812 59.7431Z" fill="#E5F5FF" />
                      <path d="M81.1963 10.1964C82.0108 9.38193 82.8563 8.61768 83.7276 7.90088C72.4782 21.5759 73.2424 41.821 86.0231 54.6017C98.8038 67.3823 119.049 68.1466 132.724 56.8972C132.007 57.7687 131.243 58.614 130.428 59.4284C116.833 73.0235 94.7915 73.0235 81.1963 59.4284C67.6012 45.8333 67.6012 23.7913 81.1963 10.1964Z" fill="#CACED2" />
                      <path d="M133.044 69.7281L137.871 64.9014C136.611 66.1613 136.611 68.2039 137.871 69.4639L161.044 92.6367C163.568 95.1615 167.264 95.8004 170.382 94.5553C169.96 95.6139 169.321 96.6063 168.463 97.4633C165.082 100.845 159.599 100.845 156.217 97.4633L133.044 74.2904C131.784 73.0307 131.784 70.9881 133.044 69.7281Z" fill="#6A6E73" />
                      <path d="M88.1834 17.1832C88.8452 16.5215 89.5358 15.9066 90.25 15.335C82.4243 25.1146 83.0393 39.467 92.0983 48.526C101.157 57.5848 115.51 58.1998 125.289 50.3742C124.718 51.0885 124.103 51.7793 123.441 52.4408C113.721 62.1613 97.904 62.1613 88.1834 52.4408C78.4629 42.7203 78.4629 26.9037 88.1834 17.1832Z" fill="#F1FAFF" />
                    </g>
                    <path d="M7.17871 138H1.51855V128.006H7.17871V129.387H3.15918V132.101H6.92578V133.475H3.15918V136.612H7.17871V138ZM13.1191 130.289C13.9714 130.289 14.6344 130.51 15.1084 130.952C15.5869 131.39 15.8262 132.094 15.8262 133.064V138H14.2197V133.365C14.2197 132.777 14.099 132.338 13.8574 132.046C13.6159 131.75 13.2422 131.602 12.7363 131.602C12.0026 131.602 11.4922 131.827 11.2051 132.278C10.9225 132.729 10.7812 133.383 10.7812 134.24V138H9.1748V130.433H10.4258L10.6514 131.458H10.7402C10.9043 131.194 11.1071 130.977 11.3486 130.809C11.5947 130.635 11.8682 130.506 12.1689 130.419C12.4743 130.332 12.791 130.289 13.1191 130.289ZM20.8916 136.838C21.1012 136.838 21.3086 136.82 21.5137 136.783C21.7188 136.742 21.9056 136.694 22.0742 136.64V137.856C21.8965 137.934 21.6663 138 21.3838 138.055C21.1012 138.109 20.8073 138.137 20.502 138.137C20.0736 138.137 19.6885 138.066 19.3467 137.925C19.0049 137.779 18.7337 137.531 18.5332 137.18C18.3327 136.829 18.2324 136.343 18.2324 135.724V131.656H17.2002V130.938L18.3076 130.371L18.834 128.751H19.8457V130.433H22.0127V131.656H19.8457V135.703C19.8457 136.086 19.9414 136.371 20.1328 136.558C20.3242 136.744 20.5771 136.838 20.8916 136.838ZM26.627 130.289C27.3014 130.289 27.8802 130.428 28.3633 130.706C28.8464 130.984 29.2178 131.378 29.4775 131.889C29.7373 132.399 29.8672 133.01 29.8672 133.721V134.582H24.8154C24.8337 135.316 25.0296 135.881 25.4033 136.277C25.7816 136.674 26.3102 136.872 26.9893 136.872C27.4723 136.872 27.9053 136.826 28.2881 136.735C28.6755 136.64 29.0742 136.501 29.4844 136.318V137.624C29.1061 137.802 28.721 137.932 28.3291 138.014C27.9372 138.096 27.4678 138.137 26.9209 138.137C26.1781 138.137 25.5241 137.993 24.959 137.706C24.3984 137.414 23.9587 136.981 23.6396 136.407C23.3252 135.833 23.168 135.12 23.168 134.268C23.168 133.42 23.3115 132.7 23.5986 132.107C23.8857 131.515 24.2891 131.064 24.8086 130.754C25.3281 130.444 25.9342 130.289 26.627 130.289ZM26.627 131.499C26.1211 131.499 25.7109 131.663 25.3965 131.991C25.0866 132.319 24.9043 132.8 24.8496 133.434H28.2949C28.2904 133.055 28.2266 132.72 28.1035 132.429C27.985 132.137 27.8027 131.909 27.5566 131.745C27.3151 131.581 27.0052 131.499 26.627 131.499ZM35.5137 130.289C35.6413 130.289 35.7803 130.296 35.9307 130.31C36.0811 130.323 36.2109 130.341 36.3203 130.364L36.1699 131.868C36.0742 131.841 35.9557 131.82 35.8145 131.807C35.6777 131.793 35.5547 131.786 35.4453 131.786C35.1582 131.786 34.8848 131.834 34.625 131.93C34.3652 132.021 34.1351 132.162 33.9346 132.354C33.734 132.54 33.5768 132.775 33.4629 133.058C33.349 133.34 33.292 133.668 33.292 134.042V138H31.6787V130.433H32.9365L33.1553 131.766H33.2305C33.3809 131.497 33.5677 131.251 33.791 131.027C34.0143 130.804 34.2695 130.626 34.5566 130.494C34.8483 130.357 35.1673 130.289 35.5137 130.289ZM44.3252 130.289C45.2822 130.289 46.0046 130.501 46.4922 130.925C46.9844 131.349 47.2305 132.009 47.2305 132.907V138H46.0889L45.7812 136.927H45.7266C45.5124 137.2 45.2913 137.426 45.0635 137.604C44.8356 137.781 44.5713 137.913 44.2705 138C43.9743 138.091 43.612 138.137 43.1836 138.137C42.7324 138.137 42.3291 138.055 41.9736 137.891C41.6182 137.722 41.3379 137.467 41.1328 137.125C40.9277 136.783 40.8252 136.35 40.8252 135.826C40.8252 135.047 41.1146 134.461 41.6934 134.069C42.2767 133.677 43.1562 133.461 44.332 133.42L45.6445 133.372V132.976C45.6445 132.451 45.5215 132.078 45.2754 131.854C45.0339 131.631 44.6921 131.52 44.25 131.52C43.8717 131.52 43.5049 131.574 43.1494 131.684C42.7939 131.793 42.4476 131.927 42.1104 132.087L41.5908 130.952C41.96 130.756 42.3792 130.597 42.8486 130.474C43.3226 130.351 43.8148 130.289 44.3252 130.289ZM45.6377 134.384L44.6602 134.418C43.8581 134.445 43.2952 134.582 42.9717 134.828C42.6481 135.074 42.4863 135.411 42.4863 135.84C42.4863 136.214 42.598 136.487 42.8213 136.66C43.0446 136.829 43.3385 136.913 43.7031 136.913C44.2591 136.913 44.7194 136.756 45.084 136.441C45.4531 136.122 45.6377 135.655 45.6377 135.04V134.384ZM58.2021 135.84C58.2021 136.337 58.0814 136.756 57.8398 137.098C57.5983 137.439 57.2451 137.699 56.7803 137.877C56.32 138.05 55.7549 138.137 55.085 138.137C54.5563 138.137 54.1006 138.098 53.7178 138.021C53.3395 137.948 52.9818 137.834 52.6445 137.679V136.291C53.0046 136.46 53.4079 136.605 53.8545 136.729C54.3057 136.852 54.7318 136.913 55.1328 136.913C55.6615 136.913 56.042 136.831 56.2744 136.667C56.5068 136.498 56.623 136.275 56.623 135.997C56.623 135.833 56.5752 135.687 56.4795 135.56C56.3883 135.427 56.2152 135.293 55.96 135.156C55.7093 135.015 55.3402 134.846 54.8525 134.65C54.374 134.459 53.9707 134.268 53.6426 134.076C53.3145 133.885 53.0661 133.655 52.8975 133.386C52.7288 133.112 52.6445 132.764 52.6445 132.34C52.6445 131.67 52.9089 131.162 53.4375 130.815C53.9707 130.465 54.6748 130.289 55.5498 130.289C56.0146 130.289 56.4521 130.337 56.8623 130.433C57.277 130.524 57.6826 130.658 58.0791 130.836L57.5732 132.046C57.2314 131.896 56.8874 131.772 56.541 131.677C56.1992 131.576 55.8506 131.526 55.4951 131.526C55.0804 131.526 54.7637 131.59 54.5449 131.718C54.3307 131.845 54.2236 132.028 54.2236 132.265C54.2236 132.442 54.276 132.593 54.3809 132.716C54.4857 132.839 54.6657 132.962 54.9209 133.085C55.1807 133.208 55.5407 133.361 56.001 133.543C56.4521 133.716 56.8418 133.898 57.1699 134.09C57.5026 134.277 57.7578 134.507 57.9355 134.78C58.1133 135.054 58.2021 135.407 58.2021 135.84ZM62.9531 130.289C63.6276 130.289 64.2064 130.428 64.6895 130.706C65.1725 130.984 65.5439 131.378 65.8037 131.889C66.0635 132.399 66.1934 133.01 66.1934 133.721V134.582H61.1416C61.1598 135.316 61.3558 135.881 61.7295 136.277C62.1077 136.674 62.6364 136.872 63.3154 136.872C63.7985 136.872 64.2314 136.826 64.6143 136.735C65.0016 136.64 65.4004 136.501 65.8105 136.318V137.624C65.4323 137.802 65.0472 137.932 64.6553 138.014C64.2633 138.096 63.7939 138.137 63.2471 138.137C62.5042 138.137 61.8503 137.993 61.2852 137.706C60.7246 137.414 60.2848 136.981 59.9658 136.407C59.6514 135.833 59.4941 135.12 59.4941 134.268C59.4941 133.42 59.6377 132.7 59.9248 132.107C60.2119 131.515 60.6152 131.064 61.1348 130.754C61.6543 130.444 62.2604 130.289 62.9531 130.289ZM62.9531 131.499C62.4473 131.499 62.0371 131.663 61.7227 131.991C61.4128 132.319 61.2305 132.8 61.1758 133.434H64.6211C64.6165 133.055 64.5527 132.72 64.4297 132.429C64.3112 132.137 64.1289 131.909 63.8828 131.745C63.6413 131.581 63.3314 131.499 62.9531 131.499ZM70.9717 130.289C71.9287 130.289 72.651 130.501 73.1387 130.925C73.6309 131.349 73.877 132.009 73.877 132.907V138H72.7354L72.4277 136.927H72.373C72.1589 137.2 71.9378 137.426 71.71 137.604C71.4821 137.781 71.2178 137.913 70.917 138C70.6208 138.091 70.2585 138.137 69.8301 138.137C69.3789 138.137 68.9756 138.055 68.6201 137.891C68.2646 137.722 67.9844 137.467 67.7793 137.125C67.5742 136.783 67.4717 136.35 67.4717 135.826C67.4717 135.047 67.7611 134.461 68.3398 134.069C68.9232 133.677 69.8027 133.461 70.9785 133.42L72.291 133.372V132.976C72.291 132.451 72.168 132.078 71.9219 131.854C71.6803 131.631 71.3385 131.52 70.8965 131.52C70.5182 131.52 70.1514 131.574 69.7959 131.684C69.4404 131.793 69.0941 131.927 68.7568 132.087L68.2373 130.952C68.6064 130.756 69.0257 130.597 69.4951 130.474C69.9691 130.351 70.4613 130.289 70.9717 130.289ZM72.2842 134.384L71.3066 134.418C70.5046 134.445 69.9417 134.582 69.6182 134.828C69.2946 135.074 69.1328 135.411 69.1328 135.84C69.1328 136.214 69.2445 136.487 69.4678 136.66C69.6911 136.829 69.985 136.913 70.3496 136.913C70.9056 136.913 71.3659 136.756 71.7305 136.441C72.0996 136.122 72.2842 135.655 72.2842 135.04V134.384ZM79.9609 130.289C80.0885 130.289 80.2275 130.296 80.3779 130.31C80.5283 130.323 80.6582 130.341 80.7676 130.364L80.6172 131.868C80.5215 131.841 80.403 131.82 80.2617 131.807C80.125 131.793 80.002 131.786 79.8926 131.786C79.6055 131.786 79.332 131.834 79.0723 131.93C78.8125 132.021 78.5824 132.162 78.3818 132.354C78.1813 132.54 78.0241 132.775 77.9102 133.058C77.7962 133.34 77.7393 133.668 77.7393 134.042V138H76.126V130.433H77.3838L77.6025 131.766H77.6777C77.8281 131.497 78.015 131.251 78.2383 131.027C78.4616 130.804 78.7168 130.626 79.0039 130.494C79.2956 130.357 79.6146 130.289 79.9609 130.289ZM85.2178 138.137C84.5023 138.137 83.8825 137.998 83.3584 137.72C82.8343 137.442 82.431 137.016 82.1484 136.441C81.8659 135.867 81.7246 135.138 81.7246 134.254C81.7246 133.333 81.8796 132.581 82.1895 131.998C82.4993 131.415 82.9277 130.984 83.4746 130.706C84.026 130.428 84.6572 130.289 85.3682 130.289C85.8193 130.289 86.2272 130.335 86.5918 130.426C86.9609 130.512 87.2731 130.619 87.5283 130.747L87.0498 132.032C86.7718 131.918 86.487 131.823 86.1953 131.745C85.9036 131.668 85.6234 131.629 85.3545 131.629C84.9124 131.629 84.5433 131.727 84.2471 131.923C83.9554 132.119 83.7367 132.41 83.5908 132.798C83.4495 133.185 83.3789 133.666 83.3789 134.24C83.3789 134.796 83.4518 135.266 83.5977 135.648C83.7435 136.027 83.96 136.314 84.2471 136.51C84.5342 136.701 84.8874 136.797 85.3066 136.797C85.7214 136.797 86.0928 136.747 86.4209 136.646C86.749 136.546 87.0589 136.416 87.3506 136.257V137.651C87.0635 137.815 86.7559 137.936 86.4277 138.014C86.0996 138.096 85.6963 138.137 85.2178 138.137ZM90.7344 127.363V130.036C90.7344 130.314 90.7253 130.585 90.707 130.85C90.6934 131.114 90.6774 131.319 90.6592 131.465H90.748C90.9076 131.201 91.1035 130.984 91.3359 130.815C91.5684 130.642 91.8281 130.512 92.1152 130.426C92.4069 130.339 92.7168 130.296 93.0449 130.296C93.6237 130.296 94.1159 130.394 94.5215 130.59C94.9271 130.781 95.237 131.08 95.4512 131.485C95.6699 131.891 95.7793 132.417 95.7793 133.064V138H94.1729V133.365C94.1729 132.777 94.0521 132.338 93.8105 132.046C93.569 131.75 93.1953 131.602 92.6895 131.602C92.2018 131.602 91.8145 131.704 91.5273 131.909C91.2448 132.11 91.042 132.408 90.9189 132.805C90.7959 133.197 90.7344 133.675 90.7344 134.24V138H89.1279V127.363H90.7344ZM106.471 141.356V138.144C106.471 137.961 106.475 137.763 106.484 137.549C106.498 137.335 106.519 137.139 106.546 136.961H106.464C106.259 137.294 105.974 137.574 105.609 137.802C105.245 138.025 104.769 138.137 104.181 138.137C103.292 138.137 102.576 137.809 102.034 137.152C101.492 136.492 101.221 135.516 101.221 134.227C101.221 133.37 101.346 132.65 101.597 132.066C101.847 131.483 102.198 131.041 102.649 130.74C103.105 130.439 103.634 130.289 104.235 130.289C104.814 130.289 105.284 130.403 105.644 130.631C106.008 130.854 106.3 131.13 106.519 131.458H106.573L106.751 130.433H108.084V141.356H106.471ZM104.659 136.845C105.115 136.845 105.479 136.758 105.753 136.585C106.026 136.412 106.225 136.15 106.348 135.799C106.471 135.443 106.537 135.004 106.546 134.479V134.233C106.546 133.377 106.407 132.725 106.129 132.278C105.851 131.832 105.356 131.608 104.646 131.608C104.044 131.608 103.597 131.843 103.306 132.312C103.014 132.777 102.868 133.424 102.868 134.254C102.868 135.092 103.014 135.735 103.306 136.182C103.602 136.624 104.053 136.845 104.659 136.845ZM116.984 130.433V138H115.72L115.501 136.981H115.412C115.253 137.241 115.05 137.458 114.804 137.631C114.558 137.799 114.284 137.925 113.983 138.007C113.683 138.093 113.366 138.137 113.033 138.137C112.464 138.137 111.976 138.041 111.57 137.85C111.169 137.654 110.862 137.353 110.647 136.947C110.433 136.542 110.326 136.018 110.326 135.375V130.433H111.939V135.074C111.939 135.662 112.058 136.102 112.295 136.394C112.536 136.685 112.91 136.831 113.416 136.831C113.904 136.831 114.291 136.731 114.578 136.53C114.865 136.33 115.068 136.034 115.187 135.642C115.31 135.25 115.371 134.769 115.371 134.199V130.433H116.984ZM122.303 130.289C122.977 130.289 123.556 130.428 124.039 130.706C124.522 130.984 124.894 131.378 125.153 131.889C125.413 132.399 125.543 133.01 125.543 133.721V134.582H120.491C120.509 135.316 120.705 135.881 121.079 136.277C121.457 136.674 121.986 136.872 122.665 136.872C123.148 136.872 123.581 136.826 123.964 136.735C124.351 136.64 124.75 136.501 125.16 136.318V137.624C124.782 137.802 124.397 137.932 124.005 138.014C123.613 138.096 123.144 138.137 122.597 138.137C121.854 138.137 121.2 137.993 120.635 137.706C120.074 137.414 119.634 136.981 119.315 136.407C119.001 135.833 118.844 135.12 118.844 134.268C118.844 133.42 118.987 132.7 119.274 132.107C119.562 131.515 119.965 131.064 120.484 130.754C121.004 130.444 121.61 130.289 122.303 130.289ZM122.303 131.499C121.797 131.499 121.387 131.663 121.072 131.991C120.762 132.319 120.58 132.8 120.525 133.434H123.971C123.966 133.055 123.902 132.72 123.779 132.429C123.661 132.137 123.479 131.909 123.232 131.745C122.991 131.581 122.681 131.499 122.303 131.499ZM131.189 130.289C131.317 130.289 131.456 130.296 131.606 130.31C131.757 130.323 131.887 130.341 131.996 130.364L131.846 131.868C131.75 131.841 131.632 131.82 131.49 131.807C131.354 131.793 131.23 131.786 131.121 131.786C130.834 131.786 130.561 131.834 130.301 131.93C130.041 132.021 129.811 132.162 129.61 132.354C129.41 132.54 129.253 132.775 129.139 133.058C129.025 133.34 128.968 133.668 128.968 134.042V138H127.354V130.433H128.612L128.831 131.766H128.906C129.057 131.497 129.243 131.251 129.467 131.027C129.69 130.804 129.945 130.626 130.232 130.494C130.524 130.357 130.843 130.289 131.189 130.289ZM132.256 130.433H134.006L135.558 134.753C135.626 134.949 135.688 135.143 135.742 135.334C135.801 135.521 135.852 135.705 135.893 135.888C135.938 136.07 135.975 136.252 136.002 136.435H136.043C136.089 136.198 136.152 135.933 136.234 135.642C136.321 135.345 136.417 135.049 136.521 134.753L138.012 130.433H139.741L136.494 139.039C136.307 139.531 136.077 139.951 135.804 140.297C135.535 140.648 135.216 140.912 134.847 141.09C134.478 141.272 134.056 141.363 133.582 141.363C133.354 141.363 133.156 141.35 132.987 141.322C132.819 141.299 132.675 141.274 132.557 141.247V139.962C132.652 139.985 132.773 140.005 132.919 140.023C133.065 140.042 133.215 140.051 133.37 140.051C133.657 140.051 133.906 139.994 134.115 139.88C134.325 139.766 134.503 139.604 134.648 139.395C134.794 139.189 134.915 138.955 135.011 138.69L135.277 137.979L132.256 130.433ZM147.343 136.838C147.552 136.838 147.76 136.82 147.965 136.783C148.17 136.742 148.357 136.694 148.525 136.64V137.856C148.348 137.934 148.118 138 147.835 138.055C147.552 138.109 147.258 138.137 146.953 138.137C146.525 138.137 146.14 138.066 145.798 137.925C145.456 137.779 145.185 137.531 144.984 137.18C144.784 136.829 144.684 136.343 144.684 135.724V131.656H143.651V130.938L144.759 130.371L145.285 128.751H146.297V130.433H148.464V131.656H146.297V135.703C146.297 136.086 146.393 136.371 146.584 136.558C146.775 136.744 147.028 136.838 147.343 136.838ZM156.763 134.199C156.763 134.828 156.681 135.386 156.517 135.874C156.353 136.362 156.113 136.774 155.799 137.111C155.484 137.444 155.106 137.699 154.664 137.877C154.222 138.05 153.723 138.137 153.167 138.137C152.647 138.137 152.171 138.05 151.738 137.877C151.305 137.699 150.929 137.444 150.61 137.111C150.296 136.774 150.052 136.362 149.879 135.874C149.706 135.386 149.619 134.828 149.619 134.199C149.619 133.365 149.763 132.659 150.05 132.08C150.341 131.497 150.756 131.052 151.294 130.747C151.832 130.442 152.472 130.289 153.215 130.289C153.912 130.289 154.527 130.442 155.061 130.747C155.594 131.052 156.011 131.497 156.312 132.08C156.612 132.663 156.763 133.37 156.763 134.199ZM151.273 134.199C151.273 134.751 151.34 135.222 151.472 135.614C151.608 136.006 151.818 136.307 152.101 136.517C152.383 136.722 152.748 136.824 153.194 136.824C153.641 136.824 154.006 136.722 154.288 136.517C154.571 136.307 154.778 136.006 154.91 135.614C155.042 135.222 155.108 134.751 155.108 134.199C155.108 133.648 155.042 133.181 154.91 132.798C154.778 132.41 154.571 132.117 154.288 131.916C154.006 131.711 153.639 131.608 153.188 131.608C152.522 131.608 152.037 131.832 151.731 132.278C151.426 132.725 151.273 133.365 151.273 134.199ZM164.405 141.363C163.38 141.363 162.594 141.179 162.047 140.81C161.5 140.44 161.227 139.923 161.227 139.258C161.227 138.793 161.372 138.399 161.664 138.075C161.956 137.756 162.373 137.535 162.915 137.412C162.71 137.321 162.532 137.18 162.382 136.988C162.236 136.792 162.163 136.576 162.163 136.339C162.163 136.056 162.243 135.815 162.402 135.614C162.562 135.414 162.801 135.22 163.12 135.033C162.724 134.865 162.405 134.591 162.163 134.213C161.926 133.83 161.808 133.381 161.808 132.866C161.808 132.319 161.924 131.854 162.156 131.472C162.389 131.084 162.728 130.79 163.175 130.59C163.621 130.385 164.161 130.282 164.795 130.282C164.932 130.282 165.08 130.291 165.239 130.31C165.403 130.323 165.554 130.341 165.69 130.364C165.832 130.382 165.939 130.403 166.012 130.426H168.63V131.321L167.345 131.561C167.468 131.734 167.566 131.932 167.639 132.155C167.712 132.374 167.748 132.613 167.748 132.873C167.748 133.657 167.477 134.274 166.935 134.726C166.397 135.172 165.654 135.396 164.706 135.396C164.478 135.386 164.257 135.368 164.043 135.341C163.879 135.441 163.754 135.553 163.667 135.676C163.58 135.794 163.537 135.929 163.537 136.079C163.537 136.202 163.58 136.302 163.667 136.38C163.754 136.453 163.881 136.507 164.05 136.544C164.223 136.58 164.433 136.599 164.679 136.599H165.984C166.814 136.599 167.447 136.774 167.885 137.125C168.322 137.476 168.541 137.991 168.541 138.67C168.541 139.531 168.186 140.194 167.475 140.659C166.764 141.129 165.741 141.363 164.405 141.363ZM164.467 140.235C165.027 140.235 165.499 140.181 165.882 140.071C166.265 139.962 166.554 139.805 166.75 139.6C166.946 139.399 167.044 139.16 167.044 138.882C167.044 138.636 166.982 138.447 166.859 138.314C166.736 138.182 166.552 138.091 166.306 138.041C166.06 137.991 165.754 137.966 165.39 137.966H164.2C163.904 137.966 163.642 138.011 163.414 138.103C163.186 138.198 163.008 138.335 162.881 138.513C162.758 138.69 162.696 138.905 162.696 139.155C162.696 139.502 162.849 139.768 163.154 139.955C163.464 140.142 163.902 140.235 164.467 140.235ZM164.781 134.343C165.251 134.343 165.599 134.215 165.827 133.96C166.055 133.7 166.169 133.336 166.169 132.866C166.169 132.356 166.05 131.973 165.813 131.718C165.581 131.463 165.235 131.335 164.774 131.335C164.323 131.335 163.979 131.465 163.742 131.725C163.51 131.984 163.394 132.369 163.394 132.88C163.394 133.34 163.51 133.7 163.742 133.96C163.979 134.215 164.326 134.343 164.781 134.343ZM173.025 130.289C173.7 130.289 174.279 130.428 174.762 130.706C175.245 130.984 175.616 131.378 175.876 131.889C176.136 132.399 176.266 133.01 176.266 133.721V134.582H171.214C171.232 135.316 171.428 135.881 171.802 136.277C172.18 136.674 172.709 136.872 173.388 136.872C173.871 136.872 174.304 136.826 174.687 136.735C175.074 136.64 175.473 136.501 175.883 136.318V137.624C175.505 137.802 175.119 137.932 174.728 138.014C174.336 138.096 173.866 138.137 173.319 138.137C172.576 138.137 171.923 137.993 171.357 137.706C170.797 137.414 170.357 136.981 170.038 136.407C169.724 135.833 169.566 135.12 169.566 134.268C169.566 133.42 169.71 132.7 169.997 132.107C170.284 131.515 170.688 131.064 171.207 130.754C171.727 130.444 172.333 130.289 173.025 130.289ZM173.025 131.499C172.52 131.499 172.109 131.663 171.795 131.991C171.485 132.319 171.303 132.8 171.248 133.434H174.693C174.689 133.055 174.625 132.72 174.502 132.429C174.383 132.137 174.201 131.909 173.955 131.745C173.714 131.581 173.404 131.499 173.025 131.499ZM180.894 136.838C181.103 136.838 181.311 136.82 181.516 136.783C181.721 136.742 181.908 136.694 182.076 136.64V137.856C181.898 137.934 181.668 138 181.386 138.055C181.103 138.109 180.809 138.137 180.504 138.137C180.076 138.137 179.69 138.066 179.349 137.925C179.007 137.779 178.736 137.531 178.535 137.18C178.335 136.829 178.234 136.343 178.234 135.724V131.656H177.202V130.938L178.31 130.371L178.836 128.751H179.848V130.433H182.015V131.656H179.848V135.703C179.848 136.086 179.943 136.371 180.135 136.558C180.326 136.744 180.579 136.838 180.894 136.838ZM192.337 135.84C192.337 136.337 192.216 136.756 191.975 137.098C191.733 137.439 191.38 137.699 190.915 137.877C190.455 138.05 189.89 138.137 189.22 138.137C188.691 138.137 188.235 138.098 187.853 138.021C187.474 137.948 187.117 137.834 186.779 137.679V136.291C187.139 136.46 187.543 136.605 187.989 136.729C188.44 136.852 188.867 136.913 189.268 136.913C189.796 136.913 190.177 136.831 190.409 136.667C190.642 136.498 190.758 136.275 190.758 135.997C190.758 135.833 190.71 135.687 190.614 135.56C190.523 135.427 190.35 135.293 190.095 135.156C189.844 135.015 189.475 134.846 188.987 134.65C188.509 134.459 188.105 134.268 187.777 134.076C187.449 133.885 187.201 133.655 187.032 133.386C186.864 133.112 186.779 132.764 186.779 132.34C186.779 131.67 187.044 131.162 187.572 130.815C188.105 130.465 188.81 130.289 189.685 130.289C190.149 130.289 190.587 130.337 190.997 130.433C191.412 130.524 191.817 130.658 192.214 130.836L191.708 132.046C191.366 131.896 191.022 131.772 190.676 131.677C190.334 131.576 189.985 131.526 189.63 131.526C189.215 131.526 188.898 131.59 188.68 131.718C188.465 131.845 188.358 132.028 188.358 132.265C188.358 132.442 188.411 132.593 188.516 132.716C188.62 132.839 188.8 132.962 189.056 133.085C189.315 133.208 189.675 133.361 190.136 133.543C190.587 133.716 190.977 133.898 191.305 134.09C191.637 134.277 191.893 134.507 192.07 134.78C192.248 135.054 192.337 135.407 192.337 135.84ZM196.89 136.838C197.099 136.838 197.307 136.82 197.512 136.783C197.717 136.742 197.904 136.694 198.072 136.64V137.856C197.895 137.934 197.664 138 197.382 138.055C197.099 138.109 196.805 138.137 196.5 138.137C196.072 138.137 195.687 138.066 195.345 137.925C195.003 137.779 194.732 137.531 194.531 137.18C194.331 136.829 194.23 136.343 194.23 135.724V131.656H193.198V130.938L194.306 130.371L194.832 128.751H195.844V130.433H198.011V131.656H195.844V135.703C195.844 136.086 195.939 136.371 196.131 136.558C196.322 136.744 196.575 136.838 196.89 136.838ZM202.577 130.289C203.534 130.289 204.257 130.501 204.744 130.925C205.236 131.349 205.482 132.009 205.482 132.907V138H204.341L204.033 136.927H203.979C203.764 137.2 203.543 137.426 203.315 137.604C203.088 137.781 202.823 137.913 202.522 138C202.226 138.091 201.864 138.137 201.436 138.137C200.984 138.137 200.581 138.055 200.226 137.891C199.87 137.722 199.59 137.467 199.385 137.125C199.18 136.783 199.077 136.35 199.077 135.826C199.077 135.047 199.367 134.461 199.945 134.069C200.529 133.677 201.408 133.461 202.584 133.42L203.896 133.372V132.976C203.896 132.451 203.773 132.078 203.527 131.854C203.286 131.631 202.944 131.52 202.502 131.52C202.124 131.52 201.757 131.574 201.401 131.684C201.046 131.793 200.7 131.927 200.362 132.087L199.843 130.952C200.212 130.756 200.631 130.597 201.101 130.474C201.575 130.351 202.067 130.289 202.577 130.289ZM203.89 134.384L202.912 134.418C202.11 134.445 201.547 134.582 201.224 134.828C200.9 135.074 200.738 135.411 200.738 135.84C200.738 136.214 200.85 136.487 201.073 136.66C201.297 136.829 201.59 136.913 201.955 136.913C202.511 136.913 202.971 136.756 203.336 136.441C203.705 136.122 203.89 135.655 203.89 135.04V134.384ZM211.566 130.289C211.694 130.289 211.833 130.296 211.983 130.31C212.134 130.323 212.264 130.341 212.373 130.364L212.223 131.868C212.127 131.841 212.008 131.82 211.867 131.807C211.73 131.793 211.607 131.786 211.498 131.786C211.211 131.786 210.938 131.834 210.678 131.93C210.418 132.021 210.188 132.162 209.987 132.354C209.787 132.54 209.63 132.775 209.516 133.058C209.402 133.34 209.345 133.668 209.345 134.042V138H207.731V130.433H208.989L209.208 131.766H209.283C209.434 131.497 209.62 131.251 209.844 131.027C210.067 130.804 210.322 130.626 210.609 130.494C210.901 130.357 211.22 130.289 211.566 130.289ZM216.591 136.838C216.8 136.838 217.008 136.82 217.213 136.783C217.418 136.742 217.605 136.694 217.773 136.64V137.856C217.596 137.934 217.366 138 217.083 138.055C216.8 138.109 216.507 138.137 216.201 138.137C215.773 138.137 215.388 138.066 215.046 137.925C214.704 137.779 214.433 137.531 214.232 137.18C214.032 136.829 213.932 136.343 213.932 135.724V131.656H212.899V130.938L214.007 130.371L214.533 128.751H215.545V130.433H217.712V131.656H215.545V135.703C215.545 136.086 215.641 136.371 215.832 136.558C216.023 136.744 216.276 136.838 216.591 136.838ZM222.326 130.289C223.001 130.289 223.579 130.428 224.062 130.706C224.546 130.984 224.917 131.378 225.177 131.889C225.437 132.399 225.566 133.01 225.566 133.721V134.582H220.515C220.533 135.316 220.729 135.881 221.103 136.277C221.481 136.674 222.009 136.872 222.688 136.872C223.172 136.872 223.604 136.826 223.987 136.735C224.375 136.64 224.773 136.501 225.184 136.318V137.624C224.805 137.802 224.42 137.932 224.028 138.014C223.636 138.096 223.167 138.137 222.62 138.137C221.877 138.137 221.223 137.993 220.658 137.706C220.098 137.414 219.658 136.981 219.339 136.407C219.024 135.833 218.867 135.12 218.867 134.268C218.867 133.42 219.011 132.7 219.298 132.107C219.585 131.515 219.988 131.064 220.508 130.754C221.027 130.444 221.633 130.289 222.326 130.289ZM222.326 131.499C221.82 131.499 221.41 131.663 221.096 131.991C220.786 132.319 220.604 132.8 220.549 133.434H223.994C223.99 133.055 223.926 132.72 223.803 132.429C223.684 132.137 223.502 131.909 223.256 131.745C223.014 131.581 222.704 131.499 222.326 131.499ZM229.921 138.137C229.019 138.137 228.294 137.809 227.747 137.152C227.205 136.492 226.934 135.519 226.934 134.233C226.934 132.935 227.209 131.952 227.761 131.287C228.317 130.622 229.048 130.289 229.955 130.289C230.338 130.289 230.673 130.341 230.96 130.446C231.247 130.547 231.493 130.683 231.698 130.856C231.908 131.03 232.086 131.223 232.231 131.438H232.307C232.284 131.296 232.257 131.093 232.225 130.829C232.197 130.56 232.184 130.312 232.184 130.084V127.363H233.797V138H232.539L232.252 136.968H232.184C232.047 137.187 231.874 137.385 231.664 137.562C231.459 137.736 231.213 137.875 230.926 137.979C230.643 138.084 230.308 138.137 229.921 138.137ZM230.372 136.831C231.06 136.831 231.546 136.633 231.828 136.236C232.111 135.84 232.257 135.245 232.266 134.452V134.24C232.266 133.393 232.129 132.743 231.855 132.292C231.582 131.836 231.083 131.608 230.358 131.608C229.78 131.608 229.338 131.843 229.032 132.312C228.731 132.777 228.581 133.427 228.581 134.261C228.581 135.095 228.731 135.733 229.032 136.175C229.338 136.612 229.784 136.831 230.372 136.831ZM235.868 137.152C235.868 136.779 235.964 136.517 236.155 136.366C236.351 136.211 236.588 136.134 236.866 136.134C237.144 136.134 237.381 136.211 237.577 136.366C237.778 136.517 237.878 136.779 237.878 137.152C237.878 137.517 237.778 137.781 237.577 137.945C237.381 138.105 237.144 138.185 236.866 138.185C236.588 138.185 236.351 138.105 236.155 137.945C235.964 137.781 235.868 137.517 235.868 137.152Z" fill="#84888C" />
                    <defs>
                      <clipPath id="clip0_755_26819">
                        <rect width="100" height="100" fill="white" transform="matrix(-1 0 0 1 171 0)" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
              )}
            </div>
            {this.state.loader && (
                <div className="loader-spinner d-flex justify-content-center align-items-center">
                  <Spinner animation="border" variant="success" />
                </div>
              )}
          </div>
        </Container>
        <Modal show={this.state.isTransactionpopupshow} onHide={this.handleModalClose} backdrop="static" keyboard={false} dialogClassName="transaction-export modal-30w" aria-labelledby="transaction-export-by-EHID">
          <Modal.Header closeButton>
              <Modal.Title>Transaction Export by EHID</Modal.Title>
          </Modal.Header>
          <Modal.Body>
          <div className="calendar-picker">
              <div className="body">
                <div className="section">
                  <div className="ehid-select">                    
                    <SingleSearchDropdownList
                      itemList={this.state.exportEhidList}
                      handleSelectedItem={this.handleEhidSelectedItem.bind(
                        this,
                        1
                      )}
                      defaultText={"Search..."}
                      defaultName={this.state.ehidPlaceholder}
                      calHomeIcon={false}
                      controlID="1"
                      pageType={"Search"}
                      isStatusbadge={false}
                    />
                  </div>
                  <ButtonGroup aria-label="Transaction-Accounting">                  
                    <Button className={this.state.exportCalendarActiveTab === "exportTransaction" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleSelectTransaction("exportTransaction") }}>Transaction Date</Button>
                    <Button className={this.state.exportCalendarActiveTab === "exportAccounting" ? "active" : ""} variant="secondary" onClick={(e) => { this.toggleSelectTransaction("exportAccounting") }}>Accounting Period</Button>
                  </ButtonGroup>
                </div>
                {this.state.exportCalendarActiveTab === "exportTransaction" &&(
                  <div className="range-sec">
                    <DateRange
                      editableDateInputs={true}
                      onChange={(item) => { this.exportDateRangeSelect([item.selection]) }}
                      moveRangeOnFirstSelection={false}
                      ranges={this.state.exportDateRange}
                    />
                    <div className="value">
                      <InputGroup className="mb-3">
                        <Form.Control aria-label="From" placeholder="From" value={this.state.exportStartDate} onChange={(e) => this.dateChange(e, "start")} onBlur={(e) => this.dateBlur(e, "start")} />
                        <Form.Control aria-label="To" placeholder="To" value={this.state.exportEndDate} onChange={(e) => this.dateChange(e, "end")} onBlur={(e) => this.dateBlur(e, "end")} />
                      </InputGroup>
                    </div>
                  </div>
                )}
                {this.state.exportCalendarActiveTab === "exportAccounting" && (
                  <div className="range-sec">
                    <Calendar
                      onlyMonthPicker
                      range
                      value={this.state.exportMonthRange}
                      onChange={(dateObjects) => { this.exportMonthRangeSelect(dateObjects)}} 
                      hideMonth={true}                                 
                    />                               
                    <div className="value">
                      <InputGroup className="mb-3">
                        <Form.Control aria-label="From" placeholder="From" value={this.state.exportStartMonthRange} onChange={(e) => this.dateChange(e, "start")}onBlur={(e) => this.dateBlur(e, "start")} />
                        <Form.Control aria-label="To" placeholder="To" value={this.state.exportEndMonthRange} onChange={(e) => this.dateChange(e, "end")} onBlur={(e) => this.dateBlur(e, "end")} />
                      </InputGroup>
                    </div>
                  </div>
                )}
              </div>
              <div className="footer">
                <div className="action d-flex justify-content-end">
                  <Button className="without-border margin-right-15" variant="primary" onClick={this.handleModalClose}>Cancel</Button>
                  <Button variant="primary" disabled = {this.state.selectedExportEhid === -1 } onClick={this.handleTransactionExportByEhidData}>Export</Button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
        
      </div >
    );
  }
}
